webpackJsonp([1],{

/***/ "+Wgm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_618824c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simpleFooterBar_vue__ = __webpack_require__("AXo6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_618824c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simpleFooterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+p9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "/Lvd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_msgDialog_vue__ = __webpack_require__("OfFN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f28b4f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_msgDialog_vue__ = __webpack_require__("Dc4g");
function injectStyle (ssrContext) {
  __webpack_require__("Sw/4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09f28b4f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_msgDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f28b4f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_msgDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/cTu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/sA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var common = {};

/*
*   获取cookie
*   @params name  cookie名
* */
common.getCookie = function (name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return (arr[2]);
    else
        return null;
};

/*
*   设置cookie
*   @params c_name  cookie名
*   @params value   cookie值
*   @expiredays     cookie保存时长
* */
common.setCookie = function(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    //console.log(123);
    //console.log("document.domain==", document.domain);
    var href = window.location.host;
    if(href.indexOf("pinganwj.com") > 0 || href.indexOf("pawjzs.com") > 0){
        document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";domain=."+ document.domain +";path=/;expires=" + exdate.toGMTString());
    }else{
        document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
    }
};

/*
*   获取cookie
*   @params name  cookie名
* */
common.delCookie = function(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = common.getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

/*
*   统计功能
* */
common.buttonCollect = function (buttonName) {
    var url = "https://image.pinganwj.com/analytics/analytics.js?v=1&type=2&content="+ buttonName + "&date=" + new Date().getTime() + parseInt(Math.random() * 1000000);
    var analytics = document.createElement('script');
    analytics.type = 'text/javascript';
    analytics.async = true;
    analytics.src = url;
    var _script = document.getElementsByTagName('script')[0];
    _script.parentNode.insertBefore(analytics, _script);
};

/*
*  调取casiframe
* */
common.addCasIframe = function (callback) {
    /*Vue.http.get(window.commonRoot + "/sso/getTicket").
    then(function (res) {
        callback();
    }).catch(function () {
        callback();
    });*/

    var isIE = /msie/i.test(navigator.userAgent) && !window.opera;
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src =  "/sso/getTicket";
    if (isIE) {
        iframe.onreadystatechange = function(){
            if(iframe.readyState == "loaded" || iframe.readyState == "complete"){
                callback();
            }
        };
    } else {
        iframe.onload = function(){
            callback();
        };
    }
    document.body.appendChild(iframe);
};

common.isIE = function(){
    var userAgent = navigator.userAgent;
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    return ( isIE || isEdge || isIE11 );
};


/* harmony default export */ __webpack_exports__["a"] = (common);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2ikA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var commonRoot = "https://www.pinganwj.com";
var enterpage="";
var domainUrl = "http://eim.pingan.com.cn";
var businessType = "WJZS";
var param="";
var subbiztype = "WJZS|01";

var sidebar = {}
sidebar.webTalkOnline = function(width,height){
    var _urlAddr = disposeUrlAddr();
    var _enterpage =  getEnterPage();
    var _subbiztype = getSubBizType();
    var _storeId = getStoreId();
    var _businessType = businessType;
    var browserTpye = appInfo();
    var _param = param; //
    domainUrl = domainUrl.replace('https:', 'http:');
    var urlparam ="encryptStr=" + _param + "&businessType=" + _businessType + "&storeId=" + _storeId+ "&subbiztype=" + _subbiztype + "&browserTpye=" + browserTpye + "&enterpage=" + _enterpage + "&urlAddr=" + _urlAddr;
    if(width && height){
        window.open(domainUrl + '/web/webtalk?' + urlparam,'', 'height='+height+',width='+width+',titlebar=no,menubar=no,toolbar=no,location=no,directories=no,scrollbars=yes,status=no,resizable=yes,top=' + (screen.availHeight - height) / 2 + ',left=' + (screen.availWidth - width) / 2 + ';');
    }else{
        window.open(domainUrl + '/web/webtalk?' + urlparam,'', 'height=610,width=774,titlebar=no,menubar=no,toolbar=no,location=no,directories=no,scrollbars=yes,status=no,resizable=yes,top=' + (screen.availHeight - 612) / 2 + ',left=' + (screen.availWidth - 774) / 2 + ';');
    }
};

function getEnterPage() {
    if (typeof(enterpage)=='undefined') {
        return '';
    }
    return encodeURIComponent(enterpage);
}
function appInfo() {
    var Sys = {};
    var ua = navigator.userAgent.toLowerCase();
    var s;
    (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
        (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
            (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
                (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
                    (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;
    var browserTpye = "";
    if (Sys.ie) {
        browserTpye = "msie" + "|" + Sys.ie
    };
    if (Sys.firefox) {
        browserTpye = "Firefox" + "|" + Sys.firefox
    };
    if (Sys.chrome) {
        browserTpye = "Chrome" + "|" + Sys.chrome
    };
    if (Sys.opera) {
        browserTpye = "Opera" + "|" + Sys.opera
    };
    if (Sys.safari) {
        browserTpye = "Safari" + "|" + Sys.safari
    };

    return browserTpye;
}

function getSubBizType() {
    if (typeof(subbiztype)=='undefined') {
        return '';
    }
    return subbiztype;
}

function getStoreId() {
    function webTalkOnline(width,height){
        var _urlAddr = disposeUrlAddr();
        var _enterpage =  getEnterPage();
        var _subbiztype = getSubBizType();
        var _storeId = getStoreId();
        var _businessType = businessType;
        var browserTpye = appInfo();
        var _param = param; //鍙傛暟鍖呮嫭鍔犲瘑涓插彿銆佷笟鍔＄被鍨�
        domainUrl = domainUrl.replace('https:', 'http:');
        var urlparam ="encryptStr=" + _param + "&businessType=" + _businessType + "&storeId=" + _storeId+ "&subbiztype=" + _subbiztype + "&browserTpye=" + browserTpye + "&enterpage=" + _enterpage + "&urlAddr=" + _urlAddr;
        if(width && height){
            window.open(domainUrl + '/web/webtalk?' + urlparam,'', 'height='+height+',width='+width+',titlebar=no,menubar=no,toolbar=no,location=no,directories=no,scrollbars=yes,status=no,resizable=yes,top=' + (screen.availHeight - height) / 2 + ',left=' + (screen.availWidth - width) / 2 + ';');
        }else{
            window.open(domainUrl + '/web/webtalk?' + urlparam,'', 'height=610,width=774,titlebar=no,menubar=no,toolbar=no,location=no,directories=no,scrollbars=yes,status=no,resizable=yes,top=' + (screen.availHeight - 612) / 2 + ',left=' + (screen.availWidth - 774) / 2 + ';');
        }
    }

    function getEnterPage() {
        if (typeof(enterpage)=='undefined') {
            return '';
        }
        return encodeURIComponent(enterpage);
    }
    function appInfo() {
        var Sys = {};
        var ua = navigator.userAgent.toLowerCase();
        var s;
        (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
            (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
                (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
                    (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
                        (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;
        var browserTpye = "";
        if (Sys.ie) {
            browserTpye = "msie" + "|" + Sys.ie
        };
        if (Sys.firefox) {
            browserTpye = "Firefox" + "|" + Sys.firefox
        };
        if (Sys.chrome) {
            browserTpye = "Chrome" + "|" + Sys.chrome
        };
        if (Sys.opera) {
            browserTpye = "Opera" + "|" + Sys.opera
        };
        if (Sys.safari) {
            browserTpye = "Safari" + "|" + Sys.safari
        };

        return browserTpye;
    }

    function getSubBizType() {
        if (typeof(subbiztype)=='undefined') {
            return '';
        }
        return subbiztype;
    }

    function getStoreId() {
        if (typeof(storeId)=='undefined') {
            return '';
        }
        return storeId;
    }

    function disposeUrlAddr(){
        var re =new RegExp("((http|ftp|https)://)(([a-zA-Z0-9\._-]+\.[a-zA-Z]{2,6})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,4})*(/[a-zA-Z0-9\&%_\./-~-]*)?");
        var _urlAddr="";
        var _urlAddrStr=window.document.location.href;
        if(re.test(_urlAddrStr)){
            _urlAddr=encodeURIComponent(_urlAddrStr);
        }
        return _urlAddr;
    }

    if (typeof(storeId)=='undefined') {
        return '';
    }
    return storeId;
}

function disposeUrlAddr(){
    var re =new RegExp("((http|ftp|https)://)(([a-zA-Z0-9\._-]+\.[a-zA-Z]{2,6})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,4})*(/[a-zA-Z0-9\&%_\./-~-]*)?");
    var _urlAddr="";
    var _urlAddrStr=window.document.location.href;
    if(re.test(_urlAddrStr)){
        _urlAddr=encodeURIComponent(_urlAddrStr);
    }
    return _urlAddr;
}

/* harmony default export */ __webpack_exports__["a"] = (sidebar);

/***/ }),

/***/ "3+jo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_common__ = __webpack_require__("/sA3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        pageType: {
            type: String,
            default: ""
        }
    },
    data: function data() {
        return {
            departmentList: [],
            locationList: [],
            navLink: []
        };
    },

    created: function created() {
        this.getDepartmentList(); //获取菜单
        this.returnSelectedType();
    },
    mounted: function mounted() {
        $(".menu-list").hover(function () {
            var _this = $(this);
            _this.addClass('selected');
        }, function () {
            var _this = $(this);
            _this.removeClass('selected');
        });
        if (this.pageType == "") {
            $(".menu-side").hover(function () {
                $(".child-menu").show();
            }, function () {
                $(".child-menu").hide();
            });
        } else {
            $(".child-menu").show();
        }
    },
    methods: {
        isSelected: function isSelected(flag) {
            if (flag) {
                return "selected";
            }
        },
        returnSelectedType: function returnSelectedType() {
            var _this = this;
            var route = _this.$route;
            var path = route.path.toLocaleLowerCase();
            _this.navLink = [{
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/" + window.areaPinyin,
                title: "首页"
            }, {
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].listRoot + "/list/",
                title: "健康商品"
            }, {
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/clinic/" + window.areaPinyin,
                title: "预约诊所"
            }, {
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/doctor/" + window.areaPinyin,
                title: "预约医生"
            }, {
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/health/",
                title: "健康资讯"
            }, {
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/disease/",
                title: "疾病手册"
            }, {
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/knowledge/",
                title: "药品信息"
            }];
            _this.navLink[0].isSelected = true;
            _this.navLink.forEach(function (item, index) {
                if (path == "/" && item.title == "首页" || _this.pageType == "index" && item.title == "首页") {
                    _this.navLink[index].isSelected = true;
                } else if (path.indexOf("clinic") > 0 && item.title == "预约诊所") {
                    _this.navLink[0].isSelected = false;
                    _this.navLink[index].isSelected = true;
                } else if (path.indexOf("doctor") > 0 && item.title == "预约医生") {
                    _this.navLink[0].isSelected = false;
                    _this.navLink[index].isSelected = true;
                } else if (path.indexOf("knowledge") > 0 && item.title == "健康助手") {
                    _this.navLink[0].isSelected = false;
                    _this.navLink[index].isSelected = true;
                }if (path.indexOf("health") > 0 && item.title == "健康资讯") {
                    _this.navLink[0].isSelected = false;
                    _this.navLink[index].isSelected = true;
                }if (path.indexOf("list") > 0 && item.title == "健康产品") {
                    _this.navLink[0].isSelected = false;
                    _this.navLink[index].isSelected = true;
                }
            });
        },
        buttonCollect: function buttonCollect(id) {
            __WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].buttonCollect(id);
        },
        returnMenuList: function returnMenuList(index) {
            return "menu-list menu-list-" + index;
        },
        returnNewHref: function returnNewHref(id) {
            return __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/clinic/" + window.areaPinyin + "/" + id;
        },
        returnNewList: function returnNewList(itemList) {
            var newList = [];
            itemList.forEach(function (item) {
                if (item.children != null && item.children.length > 0) {
                    item.children.forEach(function (list) {
                        if (list.text.length < 4) {
                            newList.push(list);
                        }
                    });
                }
            });
            return newList;
        },
        getDepartmentList: function getDepartmentList() {
            var _this = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].departmentList).then(function (response) {
                var departmentList = eval('(' + response.data.replace("var jsDepartmentList=", "") + ')');
                if (departmentList != null && departmentList instanceof Array && departmentList.length > 0) {
                    _this.departmentList = departmentList;
                }
            }).catch(function (error) {
                _this.$Message.error('数据获取失败,请稍后再试！');
            });
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "3ZqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginDialog_vue__ = __webpack_require__("mTeZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86efd480_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginDialog_vue__ = __webpack_require__("hYnn");
function injectStyle (ssrContext) {
  __webpack_require__("URsM")
  __webpack_require__("muDP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86efd480"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86efd480_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4jzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_pageTopBar__ = __webpack_require__("LX8p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_pageHeaderBar__ = __webpack_require__("Pqhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_sideBar__ = __webpack_require__("nCrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_footerBar__ = __webpack_require__("NSPu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Common_LoginDialog__ = __webpack_require__("3ZqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils_loadingBar__ = __webpack_require__("EWI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Common_menuBar__ = __webpack_require__("XRHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_utils_scrollLoading__ = __webpack_require__("QCbB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_utils_scrollLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_js_utils_scrollLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Common_msgDialog__ = __webpack_require__("/Lvd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_js_common__ = __webpack_require__("/sA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        PageTopBar: __WEBPACK_IMPORTED_MODULE_1__Common_pageTopBar__["a" /* default */],
        LoadingBar: __WEBPACK_IMPORTED_MODULE_6__Utils_loadingBar__["a" /* default */],
        SideBar: __WEBPACK_IMPORTED_MODULE_3__Common_sideBar__["a" /* default */],
        pageHeaderBar: __WEBPACK_IMPORTED_MODULE_2__Common_pageHeaderBar__["a" /* default */],
        FooterBar: __WEBPACK_IMPORTED_MODULE_4__Common_footerBar__["a" /* default */],
        MenuBar: __WEBPACK_IMPORTED_MODULE_7__Common_menuBar__["a" /* default */],
        LoginDialog: __WEBPACK_IMPORTED_MODULE_5__Common_LoginDialog__["a" /* default */],
        MsgDialog: __WEBPACK_IMPORTED_MODULE_10__Common_msgDialog__["a" /* default */]
    },
    data: function data() {
        return {
            defaultErrorImg: "this.src='https://www.pinganwj.com/resources/static/img/userlogo.png'",
            defaultClinicImg: 'this.src="https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419"',
            webRoot: __WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].commonRoot,
            districtList: [],
            departmentsList: [],
            doctorListData: [],
            pageNo: parseInt(this.$route.query.pageNo) || 1,
            totalCount: 0,
            pageSize: 10,
            nginxRoot: window.nginxRoot + '/middle/',
            searchLoading: true,
            recommendClinic: [], //推荐诊所信息
            listShow: false,
            jobTitle: [],
            areaShow: false,
            departShow: false
        };
    },

    filters: {
        workingTime: function workingTime(val) {
            if (val) {
                return new Date().getFullYear() - parseInt(val) + 1;
            }
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["b" /* mapMutations */])(['setKeyWord']), {
        returnDoctorLog: function returnDoctorLog(logo) {
            return logo.replace("http:", "");
        },
        returnClinicHref: function returnClinicHref(clinicId) {
            return window.commonRoot + "/clinic/detail/" + clinicId;
        },
        initData: function initData() {
            this.setKeyWord();
            this.getDistrictList();
            this.getDepartmentsList();
            this.getJobtitList();
            this.searchLoading = true;
            this.doctorList();
            this.getRecommendClinic();
        },
        changePage: function changePage(pageIndex) {
            this.pageNo = pageIndex;
            this.doctorList();
            $('body,html').animate({
                scrollTop: $('#list-box').offset().top - 10
            }, 0);
            return false;
        },
        judgeLogin: function judgeLogin() {
            var userInfo = this.$store.state.userInfo;
            if (userInfo != null && userInfo.userId > 0) {
                return true;
            } else {
                window.location.href = __WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].loginUrl;
                return false;
            }
        },
        loginSuccessCallBack: function loginSuccessCallBack() {
            //登陆成功之后的操作
            this.$forceUpdate();
            this.doctorList();
        },

        //选中的样式
        returnClassName: function returnClassName(index, isSelected) {
            if (index == 0) {
                if (isSelected) {
                    return "first-label ivu-checkbox-wrapper  ivu-checkbox-wrapper-checked";
                } else {
                    return "first-label ivu-checkbox-wrapper";
                }
            } else {
                if (isSelected) {
                    return "ivu-checkbox-wrapper  ivu-checkbox-wrapper-checked";
                } else {
                    return "ivu-checkbox-wrapper";
                }
            }
        },

        //区域选择
        getNewDist: function getNewDist(index, areaId, isSelected) {
            var _this = this;

            if (isSelected == "undefined") {
                isSelected = false;
            }
            //点击不限
            if (index == 0) {
                if (isSelected) {
                    return;
                } else {
                    this.districtList.forEach(function (item, i) {
                        if (i > 0) {
                            _this.districtList[i]["isSelected"] = false;
                        }
                    });
                    this.districtList[0]["isSelected"] = true;
                }
            } else {
                if (isSelected) {
                    var len = 0;
                    this.districtList.forEach(function (item, i) {
                        if (i > 0 && item.isSelected) {
                            len++;
                        }
                    });
                    if (len == 1) {
                        this.districtList[0]["isSelected"] = true;
                    }
                    this.districtList[index]["isSelected"] = false;
                } else {
                    this.districtList[0]["isSelected"] = false;
                    this.districtList[index]["isSelected"] = true;
                }
            }
            //初始化pageNo
            this.pageNo = 1;
            this.$forceUpdate();
            this.doctorList();
        },

        //科室选择
        getNewDep: function getNewDep(index, isSelected) {
            var _this2 = this;

            if (isSelected == "undefined") {
                isSelected = false;
            }
            //点击不限
            if (index == 0) {
                if (isSelected) {
                    return;
                } else {
                    this.departmentsList.forEach(function (item, i) {
                        if (i > 0) {
                            _this2.departmentsList[i]["isSelected"] = false;
                        }
                    });
                    this.departmentsList[0]["isSelected"] = true;
                }
            } else {
                if (isSelected) {
                    var len = 0;
                    this.departmentsList.forEach(function (item, i) {
                        if (i > 0 && item.isSelected) {
                            len++;
                        }
                    });
                    if (len == 1) {
                        this.departmentsList[0]["isSelected"] = true;
                    }
                    this.departmentsList[index]["isSelected"] = false;
                } else {
                    this.departmentsList[0]["isSelected"] = false;
                    this.departmentsList[index]["isSelected"] = true;
                }
            }

            //初始化pageNo
            this.pageNo = 1;
            this.$forceUpdate();
            this.doctorList();
        },
        getJobtit: function getJobtit(index, isSelected) {
            var _this3 = this;

            if (isSelected == "undefined") {
                isSelected = false;
            }
            //点击不限
            if (index == 0) {
                if (isSelected) {
                    return;
                } else {
                    this.jobTitle.forEach(function (item, i) {
                        if (i > 0) {
                            _this3.jobTitle[i]["isSelected"] = false;
                        }
                    });
                    this.jobTitle[0]["isSelected"] = true;
                }
            } else {
                if (isSelected) {
                    var len = 0;
                    this.jobTitle.forEach(function (item, i) {
                        if (i > 0 && item.isSelected) {
                            len++;
                        }
                    });
                    if (len == 1) {
                        this.jobTitle[0]["isSelected"] = true;
                    }
                    this.jobTitle[index]["isSelected"] = false;
                } else {
                    this.jobTitle[0]["isSelected"] = false;
                    this.jobTitle[index]["isSelected"] = true;
                }
            }

            //初始化pageNo
            this.pageNo = 1;
            this.$forceUpdate();
            this.doctorList();
        },


        //获取区域list
        getDistrictList: function getDistrictList() {
            var _this4 = this;

            var params = {
                cityCode: window.areaId
            };
            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].districtList, {
                params: params
            }).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    _this4.districtList = [{
                        name: "不限",
                        areaId: 0,
                        isSelected: true
                    }];
                    _this4.districtList = _this4.districtList.concat(res.result);
                }
            }).catch(function () {
                console.log('数据获取失败,请稍后再试!');
            });
        },

        //科室list
        getDepartmentsList: function getDepartmentsList() {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].department).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    _this5.departmentsList = [{
                        departmentName: "不限",
                        isSelected: true
                    }];
                    _this5.departmentsList = _this5.departmentsList.concat(res.result);
                }
            }).catch(function (err) {
                console.log('数据获取失败,请稍后再试!');
            });
        },

        //获取职称
        getJobtitList: function getJobtitList() {
            var _this6 = this;

            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].getDoctorMedicineTitleList).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    _this6.jobTitle = [{
                        dictDescription: "不限",
                        isSelected: true
                    }];
                    _this6.jobTitle = _this6.jobTitle.concat(res.result);
                }
            }).catch(function (err) {
                console.log('数据获取失败,请稍后再试!');
            });
        },


        //根据条件展示列表数据
        doctorList: function doctorList() {
            var _this7 = this;

            var dist = [];
            var departments = [];
            var medicineTitleNames = [];
            // 获取选中区域参数;
            this.districtList.forEach(function (item, index) {
                if (index > 0 && item.isSelected) {
                    dist.push(item.name);
                }
            });

            this.departmentsList.forEach(function (item, index) {
                if (index > 0 && item.isSelected) {
                    departments.push(item.departmentId);
                }
            });

            this.jobTitle.forEach(function (item, index) {
                if (index > 0 && item.isSelected) {
                    medicineTitleNames.push(item.dictDescription);
                }
            });

            var params = {
                cityCode: window.areaId,
                pageSize: this.pageSize,
                pageNo: this.pageNo,
                districtNames: dist.join(','),
                deptIds: departments.join(','),
                keyWords: this.keyWord,
                medicineTitleNames: medicineTitleNames.join(',')
            };

            __WEBPACK_IMPORTED_MODULE_9_axios___default()({
                url: __WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].doctorPage,
                method: 'post',
                data: params,
                transformRequest: [function (data) {
                    var ret = [];
                    for (var it in data) {
                        ret.push(encodeURIComponent(it) + '=' + encodeURIComponent(data[it]));
                    }
                    return ret.join("&");
                }]
            }).then(function (res) {
                if (res.data.status == "SUCCESS" && res.data.result != null && res.data.result.results != null) {
                    _this7.listShow = true;
                    _this7.searchLoading = false;
                    _this7.totalCount = res.data.result.totalCount;
                    _this7.doctorListData = res.data.result.results;
                }
            }).catch(function () {
                _this7.searchLoading = false;
                console.log('数据获取失败,请稍后再试!');
            });
        },

        //点击关注按钮
        followFun: function followFun(id, index) {
            var _this8 = this;

            var flag = this.judgeLogin();
            if (flag) {
                var params = {
                    doctorId: id
                };
                __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].insertDoctorConcern, {
                    params: params
                }).then(function (response) {
                    var res = response.data;
                    if (res.status == "SUCCESS") {
                        _this8.doctorListData[index].isConcern = '1';
                    }
                }).catch(function (error) {
                    _this8.$Message.error(error, '数据获取失败,请稍后再试!');
                });
            }
            console.log(flag, '关注按钮点击操作');
        },

        //取消关注按钮
        unfollowFun: function unfollowFun(id, index) {
            var _this9 = this;

            var params = {
                doctorId: id
            };
            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].deleteDoctorConcern, {
                params: params
            }).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    _this9.doctorListData[index].isConcern = false;
                }
            }).catch(function (error) {
                _this9.$Message.error(error, '数据获取失败,请稍后再试!');
            });
        },
        appointmentImm: function appointmentImm(id) {
            return window.commonRoot + "/doctor/detail" + "/" + id;
        },
        getRecommendClinic: function getRecommendClinic() {
            var _this10 = this;

            var params = {
                cityCode: window.areaId
            };
            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].getClinicInfo, {
                params: params
            }).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    _this10.recommendClinic = res.result;
                }
            }).catch(function (error) {
                console.log('数据获取失败,请稍后再试!');
            });
        },
        goClinicDetail: function goClinicDetail(id) {
            window.location.href = window.commonRoot + "/clinic/detail" + "/" + id;
        },
        departMore: function departMore() {
            if (!this.departShow) {
                this.departShow = true;
                $("#doctor-depart").css({
                    "height": "auto"
                });
                $("#depart-triangle").removeClass('triangle-down');
                $("#depart-triangle").addClass('triangle-up');
            } else {
                this.departShow = false;
                $("#doctor-depart").css({
                    "height": "55px"
                });
                $("#depart-triangle").removeClass('triangle-up');
                $("#depart-triangle").addClass('triangle-down');
            }
        },
        areaMore: function areaMore() {
            if (!this.areaShow) {
                this.areaShow = true;
                $("#doctor-area").css({
                    "height": "auto"
                });
                $("#area-triangle").removeClass('triangle-down');
                $("#area-triangle").addClass('triangle-up');
            } else {
                this.areaShow = false;
                $("#doctor-area").css({
                    "height": "55px"
                });
                $("#area-triangle").removeClass('triangle-up');
                $("#area-triangle").addClass('triangle-down');
            }
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["c" /* mapGetters */])(['keyWord'])),
    created: function created() {
        this.initData();
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "4n/l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4ows":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "50OH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Df2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6O99":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Ddq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-bar",style:(_vm.style)},[_c('img',{attrs:{"src":_vm.loadingImg,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7PaK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7oBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__("gsqX");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "8B1J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ADR6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("4jzW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45ab0a06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("YEZN");
function injectStyle (ssrContext) {
  __webpack_require__("cfYE")
  __webpack_require__("N2jG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45ab0a06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45ab0a06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AXo6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"footer",staticStyle:{"color":"#717171","text-align":"center","font-size":"12px","margin":"20px auto 40px"}},[_vm._v("\n \n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BYLM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_pageTopBar__ = __webpack_require__("LX8p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_pageHeaderBar__ = __webpack_require__("Pqhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_sideBar__ = __webpack_require__("nCrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_footerBar__ = __webpack_require__("NSPu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_loadingBar__ = __webpack_require__("EWI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Common_menuBar__ = __webpack_require__("XRHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Common_msgDialog__ = __webpack_require__("/Lvd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_js_common__ = __webpack_require__("/sA3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        PageTopBar: __WEBPACK_IMPORTED_MODULE_1__Common_pageTopBar__["a" /* default */],
        LoadingBar: __WEBPACK_IMPORTED_MODULE_5__Utils_loadingBar__["a" /* default */],
        SideBar: __WEBPACK_IMPORTED_MODULE_3__Common_sideBar__["a" /* default */],
        pageHeaderBar: __WEBPACK_IMPORTED_MODULE_2__Common_pageHeaderBar__["a" /* default */],
        FooterBar: __WEBPACK_IMPORTED_MODULE_4__Common_footerBar__["a" /* default */],
        MenuBar: __WEBPACK_IMPORTED_MODULE_6__Common_menuBar__["a" /* default */],
        swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"],
        MsgDialog: __WEBPACK_IMPORTED_MODULE_7__Common_msgDialog__["a" /* default */]
    },
    data: function data() {
        return {
            staticRoot: __WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].static,
            healthMore: __WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].commonRoot + "/health",
            productDefault: __WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].static + "/img/product_img.png",
            errorImg: __WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].static + "/img/errorImg.jpg",
            adImg: __WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].static + '/img/ad.jpg',
            defaultClinicImg: 'this.src="https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419"',
            sliderIndex: 0,
            clinicUrl: "",
            advertisementList: [],
            advertisementListLoad: true,
            clinicListLoad: true,
            informationListLoad: true,
            productInfoListLoad: true,
            getSecAdLoad: true,
            getThirdAdLoad: true,
            carouselList: [],
            clinicList: [],
            informationList: [],
            productInfoList: [],
            secAdList: [],
            thirdAdList: [],
            swiperOption: {
                autoplay: 3000,
                direction: 'vertical',
                effect: 'fade',
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                fade: {
                    crossFade: true
                },
                pagination: '.swiper-pagination'
            }
        };
    },

    created: function created() {
        this.getCarouselList();
        this.getFourAd();
        this.getSecAd();
        this.getThirdAd();
        this.getClinicInfo();
        this.getInformation();
        this.getProductInfo();
    },
    mounted: function mounted() {},
    methods: {
        returnDoctorLog: function returnDoctorLog(logo) {
            return logo.replace("http:", "");
        },
        returnResult: function returnResult(index, item) {
            var flag = false;
            if (index == 0) {
                // && item.prdList != null && item.prdList.length >= 3
                if (item.fieldName != null && item.fieldPicUrl != null && item.prdList != null && item.prdList.length >= 1) {
                    flag = true;
                }
            } else {
                if (item.prdList != null && item.prdList.length >= 1) {
                    flag = true;
                }
            }
            return flag;
        },
        returnSoldNum: function returnSoldNum(num) {
            if (num != null || num != "null") {
                return num;
            } else {
                return 0;
            }
        },
        returnImgPath: function returnImgPath(path, root, type) {
            if (type == "middle") {
                if (path != null && path.length > 0) {
                    return root + "middle/" + path;
                } else {
                    return "https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419";
                    //return url.static + '/img/clinicDefault.jpg'
                }
            } else {
                if (path != null && path.length > 0) {
                    return root + path;
                } else {
                    return "https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419";
                }
            }
        },
        formatCount: function formatCount(num) {
            if (parseFloat(num) == "NaN") {
                return 0;
            } else {
                var arr = num.toString().split(".");
                if (arr.length > 1 && arr[1] > 0) {
                    return num;
                } else {
                    return parseFloat(num);
                }
            }
        },
        returnDetailHeathDetail: function returnDetailHeathDetail(id) {
            return __WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].commonRoot + '/health/detail/' + id;
        },
        goToDetailClinic: function goToDetailClinic(id) {
            return __WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].commonRoot + "/clinic/detail/" + id;
        },
        returnBgColor: function returnBgColor(color) {
            return "background-color: " + color;
        },
        getFourAd: function getFourAd() {
            var _this = this;
            var params = {
                cityCode: window.areaId,
                adType: 8
            };
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].getAdvertisement, {
                params: params
            }).then(function (response) {
                var res = response.data;
                _this.advertisementListLoad = false;
                if (res.status == "SUCCESS") {
                    _this.advertisementList = res.result;
                }
            }).catch(function (error) {
                _this.$Message.error(error, '数据获取失败,请稍后再试!');
            });
        },
        getSecAd: function getSecAd() {
            var _this = this;
            var params = {
                cityCode: window.areaId,
                adType: 10
            };
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].getAdvertisement, {
                params: params
            }).then(function (response) {
                var res = response.data;
                _this.getSecAdLoad = false;
                if (res.status == "SUCCESS") {
                    _this.secAdList = res.result;
                }
            }).catch(function (error) {
                _this.$Message.error(error, '数据获取失败,请稍后再试!');
            });
        },
        getThirdAd: function getThirdAd() {
            var _this = this;
            var params = {
                cityCode: window.areaId,
                adType: 11
            };
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].getAdvertisement, {
                params: params
            }).then(function (response) {
                var res = response.data;
                _this.getThirdAdLoad = false;
                if (res.status == "SUCCESS") {
                    _this.thirdAdList = res.result;
                }
            }).catch(function (error) {
                _this.$Message.error(error, '数据获取失败,请稍后再试!');
            });
        },
        getCarouselList: function getCarouselList() {
            var _this = this;
            var params = {
                cityCode: window.areaId
            };
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].getBannerInfo, {
                params: params
            }).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    _this.carouselList = res.result;
                }
            }).catch(function (error) {
                _this.$Message.error(error, '数据获取失败,请稍后再试!');
            });
        },
        getClinicInfo: function getClinicInfo() {
            var _this = this;
            _this.clinicUrl = __WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].commonRoot + "/clinic/" + window.areaPinyin;
            var params = {
                cityCode: window.areaId
            };
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].getClinicInfo, {
                params: params
            }).then(function (response) {
                _this.clinicListLoad = false;
                var res = response.data;
                if (res.status == "SUCCESS") {
                    _this.clinicList = res.result;
                }
            }).catch(function (error) {
                _this.$Message.error(error, '数据获取失败,请稍后再试!');
            });
        },
        getInformation: function getInformation() {
            var _this = this;
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].getInformation).then(function (response) {
                _this.informationListLoad = false;
                if (response.data.result != null && response.data.result.length > 0) {
                    _this.informationList = response.data.result;
                }
            }).catch(function (error) {
                _this.$Message.error(error, '数据获取失败,请稍后再试!');
            });
        },
        getProductInfo: function getProductInfo() {
            var _this = this;
            var params = {
                cityCode: window.areaId
            };
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_9__config_url__["a" /* default */].getProductInfo, {
                params: params
            }).then(function (response) {
                _this.productInfoListLoad = false;
                if (response.data.result != null && response.data.result.length > 0) {
                    _this.productInfoList = response.data.result;
                }
            }).catch(function () {
                _this.$Message.error('数据获取失败,请稍后再试!');
            });
        }
    }
});

/***/ }),

/***/ "Dc4g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow && _vm.msgList  != null && _vm.msgList.length > 0)?_c('transition',{attrs:{"name":"custom-classes-transition","enter-active-class":"animated bounceInRight","leave-active-class":"animated fadeOutRightBig"}},[_c('div',{staticClass:"msg-dialog"},[_c('div',{staticClass:"msg-dialog-box"},[_c('div',{staticClass:"msg-dialog-header"},[_c('i',{staticClass:"msg-icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.defaultList.topic))]),_vm._v(" "),_c('a',{staticClass:"close",on:{"click":_vm.closeMsgDialog}})]),_vm._v(" "),_c('div',{staticClass:"msg-dialog-content"},[_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.subStringHide(_vm.defaultList.content))}}),_vm._v(" "),(_vm.defaultList.link != null && _vm.defaultList.link.length > 0)?_c('a',{attrs:{"target":"_blank","href":_vm.defaultList.link}},[_vm._v("查看")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"msg-dialog-page"},[_c('span',{staticClass:"prev",on:{"click":_vm.prevClick}},[_vm._v("<")]),_vm._v(" "),_c('span',{staticClass:"page-count"},[_vm._v(_vm._s(_vm.currentPage)+" / "+_vm._s(_vm.totalCount))]),_vm._v(" "),_c('span',{staticClass:"next",on:{"click":_vm.nextClick}},[_vm._v(">")])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EWI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadingBar_vue__ = __webpack_require__("V5z6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ea585af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadingBar_vue__ = __webpack_require__("7Ddq");
function injectStyle (ssrContext) {
  __webpack_require__("4ows")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ea585af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadingBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ea585af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadingBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FKvS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var url = {};
var host = "";
var host_proxy_8080 = "proxy_8080";
var api_host = "/";

url.host = host;
url.commonRoot =  window.commonRoot;
url.casRoot = window.casRoot;
url.hyqtRoot = window.hyqtRoot;
url.clinicRoot = window.clinicRoot;
url.listRoot = window.listRoot;
url.busRoot = window.busRoot;
url.cartRoot= window.cartRoot;
url.myClinic = window.myClinic;
url.college = window.college;
url.renZheng = window.renZheng;
url.nginxRoot = window.nginxRoot;
if(true){
    host = window.commonRoot;
    url.static = "/resources/static";
    url.userId = "";

    url.saveFeedbackPicture = host + "/sso/feedback/saveFeedbackPicture";
    url.saveFeedbackInfo = host + "/sso/feedback/saveFeedbackInfo";
    url.getFeedbackInfo = host + "/sso/feedback/getFeedbackInfo";
    url.saveFeedbackEvaluate = host + "/sso/feedback/saveFeedbackEvaluate";
    url.getUserMobile = host + "/sso/feedback/getUserMobile";
}else{
    host = "/" + host_proxy_8080;
    url.static = "/static";
    url.userId = "360";

    url.saveFeedbackPicture = host + "/feedback/saveFeedbackPicture";
    url.saveFeedbackInfo = host + "/feedback/saveFeedbackInfo";
    url.getFeedbackInfo = host + "/feedback/getFeedbackInfo";
    url.saveFeedbackEvaluate = host + "/feedback/saveFeedbackEvaluate";
    url.getUserMobile = host + "/feedback/getUserMobile";
}

url.loginUrl = window.casRoot+ "/login?service="+ encodeURIComponent(window.commonRoot +"/sso/toSSoLogin.do?targeturl=" + window.location.href);
url.registerUrl =  window.casRoot+ "/register?service="+ encodeURIComponent(window.commonRoot +"/sso/toSSoLogin.do?targeturl=" + window.location.href);
url.departmentList = host + "/dynamic/js/departmentList.js";
url.locationList = host + "/dynamic/js/locationList.js";
url.getAdvertisement = host + "/advertisement/getAdvertisement.do";
url.getHotWord = host + "/hotWord/getHotWord.do";
url.getBannerInfo = host + "/banner/getBannerInfo.do";
url.getClinicInfo = host + "/homePageclinic/getClinicInfo.do";
url.getOpenCitySite = host + "/citySite/getOpenCitySite.do";
url.locationCity = host + "/citySite/locationCity.do";
url.getUserInfo = host + "/login/c/getUserInfo";
url.getInformation = host + "/infomation/getInformation.do";
url.getProductInfo = host + "/product/getProductInfo.do";
url.getCartNum = host + "/cartInterface/c/getCartNum";
url.getAboutLink = host + "/pagefoot/getAboutLink";
url.checkCitysiteAndGetCity = host + "/citySite/checkCitysiteAndGetCity";
url.etTicket = host + "/sso/getTicket";
url.imgUpload = host + "/posts/";
url.findMessage = host + "/messageInterface/findMessage.do";
url.forgotPassword = window.casRoot + "/forgotPassword";
url.getPicCheckFlag = host + "/login/getPicCheckFlag.do";
url.loginByMobile = host + "/login/loginByMobile.do";
url.loginByWeb = host + "/login/loginByWeb.do";
url.loginSSO = window.commonRoot + "/login/loginSSO.do";
url.sendSmsCode = host + "/login/sendSmsCode.do";

url.districtList = host + '/area/districtList.do';
url.doctorPage = host +　'/doctorPage/list.do'
url.department = host + '/department/list.do'
url.clinicPage = host +　'/clinicPage/list.do'
url.getRecomentProduct = window.listRoot + '/wjPrdDetail/getRecomentProduct.do';

url.deleteDoctorConcern = host + '/doctorInterface/deleteDoctorConcern.do';
url.insertDoctorConcern = host + '/doctorInterface/insertDoctorConcern.do';
url.deleteClinicConcern = host + '/clinicInterface/deleteClinicConcern.do';
url.insertClinicConcern = host + '/clinicInterface/insertClinicConcern.do';

url.getDoctorMedicineTitleList = host + '/doctorPage/getDoctorMedicineTitleList.do';
/* harmony default export */ __webpack_exports__["a"] = (url);



/***/ }),

/***/ "GPws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08455108_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_vue__ = __webpack_require__("QrfJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08455108_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Gcla":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reply_vue__ = __webpack_require__("I3Sa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93e80d52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reply_vue__ = __webpack_require__("m/mO");
function injectStyle (ssrContext) {
  __webpack_require__("50OH")
  __webpack_require__("h6yn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93e80d52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reply_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93e80d52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reply_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I3Sa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Common_simpleHeaderBar__ = __webpack_require__("rpep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_simpleFooterBar__ = __webpack_require__("+Wgm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils_loadingBar__ = __webpack_require__("EWI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        simpleHeaderBar: __WEBPACK_IMPORTED_MODULE_0__Common_simpleHeaderBar__["a" /* default */],
        simpleFooterBar: __WEBPACK_IMPORTED_MODULE_1__Common_simpleFooterBar__["a" /* default */],
        LoadingBar: __WEBPACK_IMPORTED_MODULE_2__Utils_loadingBar__["a" /* default */]
    },
    data: function data() {
        return {
            submitLoading: false,
            loading: true,
            maxLength200: 200,
            feedbackSource: 0,
            result: {},
            feedbackId: this.$route.query.feedbackId,
            reply: {
                solveState: 1,
                evaluateStars: 1,
                evaluateContent: ""
            }
        };
    },

    created: function created() {
        this.getFeedbackInfo();
    },
    mounted: function mounted() {},
    methods: {
        getFeedbackInfo: function getFeedbackInfo() {
            var _this = this;
            var params = {
                feedbackId: _this.feedbackId,
                feedbackSource: _this.feedbackSource,
                userId: __WEBPACK_IMPORTED_MODULE_3__config_url__["a" /* default */].userId
            };
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config_url__["a" /* default */].getFeedbackInfo, {
                params: params
            }).then(function (response) {
                var res = response.data;
                _this.loading = false;
                if (res.status == "SUCCESS" && res.result != null) {
                    _this.result = res.result;
                    _this.feedbackSource = res.result.FeedBack.feedbackSource;
                }
            }).catch(function () {
                _this.$Message.error('数据获取失败,请稍后再试!');
            });
        },
        handleSubmit: function handleSubmit() {
            this.submitLoading = true;
            var _this = this;
            var params = {
                feedbackId: _this.feedbackId,
                solveState: _this.reply.solveState,
                evaluateStars: _this.reply.evaluateStars,
                evaluateContent: _this.reply.evaluateContent.trim(),
                feedbackSource: _this.feedbackSource
            };
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config_url__["a" /* default */].saveFeedbackEvaluate, {
                params: params
            }).then(function (response) {
                var res = response.data;
                _this.submitLoading = false;
                if (res.status == "SUCCESS") {
                    _this.$Message.success('提交成功');
                    _this.getFeedbackInfo();
                } else {
                    _this.$Message.error(res.errorMsg);
                }
            }).catch(function () {
                _this.$Message.error('数据获取失败,请稍后再试!');
            });
        }
    }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("mUbh");






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* default */]
}));

/***/ }),

/***/ "KKUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-page"},[_c('PageTopBar'),_vm._v(" "),_c('pageHeaderBar'),_vm._v(" "),_c('SideBar'),_vm._v(" "),_c('MenuBar'),_vm._v(" "),_c('div',{staticClass:"grey-body"},[_c('div',{staticClass:"list-bread"},[_c('a',{attrs:{"href":_vm.webRoot}},[_vm._v("首页")]),_vm._v(" "),_c('span',[_vm._v(">")]),_vm._v(" "),_c('a',[_vm._v("就近预约")])]),_vm._v(" "),_c('div',{staticClass:"list-body shop-list"},[_c('div',{staticClass:"search-area"},[_c('ul',[_c('li',{staticClass:"more-list",attrs:{"id":"clinic-area"}},[_c('span',{staticClass:"area-txt"},[_vm._v("区       域：")]),_vm._v(" "),_c('div',{staticClass:"search-list list limited dist"},[_vm._l((_vm.districtList),function(item,index){return _c('label',{class:_vm.returnClassName(index, item.isSelected),attrs:{"data-index":index,"title":item.name},on:{"click":function($event){_vm.getNewDist(index, item.areaId,item.isSelected)}}},[_c('p',[_vm._v(_vm._s(item.name))])])}),_vm._v(" "),(_vm.districtList.length > 10)?_c('div',{staticClass:"de-more",on:{"click":_vm.areaMore}},[_vm._v("\n                                更多\n                                "),_c('div',{staticClass:"triangle triangle-down",attrs:{"id":"area-triangle"}})]):_vm._e()],2)]),_vm._v(" "),_c('li',{staticClass:"more-list",attrs:{"id":"clinic-depart"}},[_c('span',{staticClass:"area-txt"},[_vm._v("科       室：")]),_vm._v(" "),_c('div',{staticClass:"search-list list limited"},[_vm._l((_vm.departmentsList),function(item,index){return _c('label',{class:_vm.returnClassName(index, item.isSelected),attrs:{"data-index":index,"title":item.departmentName},on:{"click":function($event){_vm.getNewDep(index, item.isSelected)}}},[_c('p',[_vm._v("\n                                "+_vm._s(item.departmentName))])])}),_vm._v(" "),(_vm.departmentsList.length > 10)?_c('div',{staticClass:"de-more",on:{"click":_vm.departMore}},[_vm._v("\n                                更多\n                                "),_c('div',{staticClass:"triangle triangle-down",attrs:{"id":"depart-triangle"}})]):_vm._e()],2)]),_vm._v(" "),_c('li',[_c('span',{staticClass:"area-txt"},[_vm._v("医院资质：")]),_vm._v(" "),_c('div',{staticClass:"search-list list limited"},_vm._l((_vm.hospitalQualification),function(item,index){return _c('label',{class:_vm.returnClassName(index, item.isSelected),attrs:{"data-index":index,"title":item.name},on:{"click":function($event){_vm.getNewHospital(index, item.isSelected)}}},[_c('p',[_vm._v(_vm._s(item.name))])])}))])])]),_vm._v(" "),(_vm.searchLoading)?_c('LoadingBar',{attrs:{"height":"120px"}}):_vm._e(),_vm._v(" "),(_vm.listShow)?_c('div',{staticClass:"list-content clearfix",attrs:{"id":"list-box"}},[_c('div',{staticClass:"list-left recommed-doctor"},[_c('div',{staticClass:"clinic-list"},[_vm._l((_vm.clinicListData),function(item,index){return (_vm.clinicListData.length>0)?[_c('div',{staticClass:"clinic-groom clearfix"},[_c('a',{staticClass:"doc-portrait",attrs:{"href":_vm.appointmentImm(item.id)}},[_c('img',{staticClass:"doc-img",attrs:{"src":_vm.returnImgPath(item.clinicFacadeName, _vm.nginxRoot, 'middle'),"alt":"","onerror":_vm.defaultClinicImg}})]),_vm._v(" "),_c('div',{staticClass:"doc-list"},[_c('ul',[_c('li',[_c('h1',[_c('a',{attrs:{"href":_vm.appointmentImm(item.id)}},[_vm._v(_vm._s(item.clinicName))])])]),_vm._v(" "),_c('li',{staticClass:"shop-certification"},[(item.unionFlag== '1')?_c('span',{staticStyle:{"border":"1px solid #259be2","color":"#259be2"}},[_vm._v("联盟")]):_vm._e(),_vm._v(" "),(item.auditResult == '02' || item.auditResult == '11' || item.auditResult == '15')?_c('span',{staticStyle:{"border":"1px solid #fd8e24","color":"#fd8e24"}},[_vm._v("三星认证")]):(item.auditResult == '04')?_c('span',{staticStyle:{"border":"1px solid #fd8e24","color":"#fd8e24"}},[_vm._v("四星认证")]):(item.auditResult == '05')?_c('span',{staticStyle:{"border":"1px solid #fd8e24","color":"#fd8e24"}},[_vm._v("五星认证")]):_vm._e(),_vm._v(" "),(item.isMedicalInsurance == '1')?_c('span',{staticStyle:{"border":"1px solid #3ebc77","color":"#3ebc77"}},[_vm._v("医保")]):_vm._e(),_vm._v(" "),(item.isCommercialInsurance == '1')?_c('span',{staticStyle:{"border":"1px solid #bc00ae","color":"#bc00ae"}},[_vm._v("商保")]):_vm._e()]),_vm._v(" "),_c('li',[_c('p',{staticStyle:{"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_c('span',[_vm._v("科        室：")]),_c('span',[_vm._v(_vm._s(item.diagnosisType1))])])]),_vm._v(" "),_c('li',[_c('p',{staticStyle:{"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_vm._v("地        址："+_vm._s(item.address))])]),_vm._v(" "),(item.prdNames)?_c('li',[_c('p',{staticStyle:{"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_c('span',[_vm._v("健康商品：")]),_c('span',[_vm._v(_vm._s(item.prdNames))])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"operating"},[(item.isConcern == '1')?_c('div',{staticClass:"btn-follow",on:{"click":function($event){_vm.unfollowFun(item.id,index)}}},[_c('span',{staticClass:"follow"}),_c('em',[_vm._v("已关注")])]):_c('div',{staticClass:"btn-follow",on:{"click":function($event){_vm.followFun(item.id,index)}}},[_c('span',{staticClass:"unfollow"}),_c('em',[_vm._v("立即关注")])]),_vm._v(" "),_c('p',{staticClass:"timeplan"},[_vm._v(_vm._s(item.openingTime))]),_vm._v(" "),(item.isBooking=='1')?_c('a',{staticClass:"btn-reserve",attrs:{"href":_vm.appointmentImm(item.id)}},[_vm._v("立即预约")]):_c('p',{staticClass:"btn-reserve btn-not-booking"},[_vm._v("立即预约")])])])]:_vm._e()})],2),_vm._v(" "),(_vm.clinicListData.length==0)?_c('div',{staticClass:"no-match"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.totalCount)?_c('Page',{staticClass:"list-page",attrs:{"total":_vm.totalCount,"current":_vm.pageNo,"page-size":_vm.pageSize},on:{"on-change":_vm.changePage}}):_vm._e()],1),_vm._v(" "),(_vm.fitProduct.length > 0)?_c('div',{staticClass:"list-right"},[_c('h1',[_vm._v("健康产品")]),_vm._v(" "),_c('ul',[_vm._l((_vm.fitProduct),function(item,index){return [_c('li',[_c('a',{attrs:{"href":item.targetUrl}},[_c('div',{staticClass:"pro-img"},[_c('img',{attrs:{"src":_vm.nginxRoot + item.prdPhoto,"alt":"","onerror":_vm.defaultErrorImg}})]),_vm._v(" "),_c('div',{staticClass:"pro-name"},[_c('p',{staticStyle:{"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_vm._v(_vm._s(item.prdName))]),_c('span',[_vm._v("¥"),_c('em',[_vm._v(" "+_vm._s(parseInt(item.prdPrice)))])])])])])]})],2)]):_vm._e()]):_vm._e()],1)]),_vm._v(" "),_c('FooterBar'),_vm._v(" "),_c('MsgDialog'),_vm._v(" "),_c('LoginDialog',{on:{"on-success":_vm.loginSuccessCallBack}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('i'),_vm._v("未搜索到符合条件的诊所")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LStO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            year: new Date().getFullYear(),
            hotLink: [{
                title: "入驻诊所国家",
                children: [{
                    title: "新加坡",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].clinicRoot + "/login/register.do"
                }, {
                    title: "日本",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].clinicRoot + "/login/register.do"
                }, {
                    title: "韩国",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].clinicRoot + "/login/register.do"
                }]
            }, {
                title: "为用户服务",
                children: [{
                    title: "找诊所",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/clinic"
                }, {
                    title: "找医生",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/doctor"
                }, {
                    title: "预约诊所",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/clinic"
                }, {
                    title: "预约医生",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/doctor"
                }, {
                    title: "找精品资讯",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/health"
                }, {
                    title: "找疾病百科",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/disease"
                }, {
                    title: "找药品百科",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/knowledge/sou"
                }, {
                    title: "找职位",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].hyqtRoot + "/security/jobListPage/jobList.w"
                }]
            }, {
                title: "为诊所赋能",
                children: [{
                    title: "加盟万家",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].clinicRoot + "/login/register.do"
                }, {
                    title: "权威认证",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].clinicRoot + "/index/getHomeCaseModel.do?caseModel=wjrz"
                }, {
                    title: "云诊所",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/cloudclinic"
                }, {
                    title: "万家学院",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].college
                }, {
                    title: "万家人才",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].clinicRoot + "/index/getHomeCaseModel.do?caseModel=wjrc"
                }]
            }, {
                title: "移动万家",
                children: [{
                    title: "移动诊所",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/appDownload?tab=app"
                }, {
                    title: "微信万家",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/appDownload?tab=webChat"
                }]
            }, {
                title: "更多",
                children: [{
                    title: "网站导航",
                    href: ""
                }, {
                    title: "帮助中心",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/help"
                }, {
                    title: "问题反馈",
                    href: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/sso/feedback?feedbackSource=6",
                    blank: true
                }]
            }],
            partner: [{
                href: "http://health.pingan.com/",
                title: "平安健康险",
                className: "brand-1",
                imgUrl: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].static + "/img/brand-jkx.png"
            }, {
                href: "http://one.pingan.com/index.jsp",
                title: "平安一账通",
                className: "brand-2",
                imgUrl: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].static + "/img/brand-yzt.png"
            }, {
                href: "https://www.yqb.com/",
                title: "壹钱包",
                className: "brand-3",
                imgUrl: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].static + "/img/brand-yiqianbao.png"
            }, {
                href: "http://annuity.pingan.com/",
                title: "平安养老险",
                className: "brand-4",
                imgUrl: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].static + "/img/brand-ylx.png"
            }, {
                href: "http://www.baikemy.com/",
                title: "百科名医",
                className: "brand-5",
                imgUrl: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].static + "/img/brand-bkmz.png"
            },
            /*{
                href: "",
                title: "",
                className: "brand-6",
                imgUrl: url.static + "/img/brand-ieem.jpg"
            },*/
            {
                href: "http://bank.pingan.com/",
                title: "平安银行",
                className: "brand-7",
                imgUrl: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].static + "/img/brand-brank.png"
            }],
            bottomLink: []
        };
    },

    created: function created() {
        this.getAboutLink();
    },
    mounted: function mounted() {
        var _this = this;
        $("#friend-link").scrollLoading({
            callback: function callback() {
                _this.getAboutLink();
            }
        });
    },
    methods: {
        goOutPage: function goOutPage(href) {
            this.$Modal.confirm({
                content: '<span style="font-size: 14px;">您将跳出云诊所系统，是否继续？</span>',
                onOk: function onOk() {
                    window.open(href);
                },
                onCancel: function onCancel() {}
            });
        },
        returnHref: function returnHref(id) {
            return __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].commonRoot + "/about/" + id;
        },

        //获取关于万家
        getAboutLink: function getAboutLink() {
            var _this = this;
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].getAboutLink).then(function (res) {
                if (res.data.result != null) {
                    _this.bottomLink = res.data.result;
                }
            }).catch(function (error) {
                _this.$Message.error('数据获取失败,请稍后再试！');
            });
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "LX8p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pageTopBar_vue__ = __webpack_require__("XEa9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50510b1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pageTopBar_vue__ = __webpack_require__("NANv");
function injectStyle (ssrContext) {
  __webpack_require__("4n/l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50510b1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pageTopBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50510b1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pageTopBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec370722_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("7PaK");
function injectStyle (ssrContext) {
  __webpack_require__("5Df2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec370722_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MPMi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mimf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"menu-warp"},[_c('div',{staticClass:"menu-side"},[_c('span',{staticClass:"all"},[_vm._v("全部服务")]),_vm._v(" "),_c('ul',{staticClass:"child-menu",staticStyle:{"display":"none"}},_vm._l((_vm.departmentList),function(list,index){return (index <= 4)?_c('li',{class:_vm.returnMenuList(index)},[(index == 0)?_c('i',{staticClass:"icon-logo icon-nwk"}):_vm._e(),_vm._v(" "),(index == 1)?_c('i',{staticClass:"icon-logo icon-fk"}):_vm._e(),_vm._v(" "),(index == 2)?_c('i',{staticClass:"icon-logo icon-child"}):_vm._e(),_vm._v(" "),(index == 3)?_c('i',{staticClass:"icon-logo icon-zhongyi"}):_vm._e(),_vm._v(" "),(index == 4)?_c('i',{staticClass:"icon-logo icon-kq"}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"arr"}),_vm._v(" "),_c('div',{staticClass:"title"},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(list.text))])]),_vm._v(" "),_c('div',{staticClass:"menu-children"},_vm._l((_vm.returnNewList(list.children)),function(item,_index){return _c('span',[(_index < 3)?_c('a',{attrs:{"href":_vm.returnNewHref(list.id)},on:{"click":function($event){_vm.buttonCollect('web-index-department');}}},[_vm._v(_vm._s(item.text))]):_vm._e(),_vm._v(" "),(_index < 2 && _index < _vm.returnNewList(list.children).length  -1)?_c('span',{staticClass:"line"},[_vm._v("|")]):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"menu-third-children"},_vm._l((list.children),function(item){return _c('dl',[_c('dt',[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('dd',_vm._l((item.children),function(list2,index){return _c('span',[_c('a',{attrs:{"href":_vm.returnNewHref(list.id)},on:{"click":function($event){_vm.buttonCollect('web-index-department');}}},[_vm._v(_vm._s(list2.text))]),_vm._v(" "),(index < item.children.length  - 1)?_c('span',{staticClass:"line"},[_vm._v("|")]):_vm._e()])}))])}))]):_vm._e()}))]),_vm._v(" "),_c('div',{staticClass:"menu-link"},_vm._l((_vm.navLink),function(item,index){return _c('a',{class:_vm.isSelected(item.isSelected),attrs:{"data-index":index,"href":item.url}},[_vm._v(_vm._s(item.title))])})),_vm._v(" "),_c('div',{staticClass:"clear"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N+zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("+p9J");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e316b28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("TNvR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e316b28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "N27l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_common__ = __webpack_require__("/sA3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/*import {select, option} from "iview"*/
/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        /*select: select,
        option: option*/
    },
    data: function data() {
        return {
            imgLogo: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].static + "/img/logo_main.png",
            hot_line: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].static + "/img/hot_line.png",
            webRoot: window.commonRoot + "/" + window.areaPinyin,
            searchHolderItem: {},
            defaultSearchHolder: {
                hotWordTypeName: "诊所",
                placeHolder: "请输入诊所名称，科室名称、医生名称",
                targetUrl: ""
            },
            searchHolder: [{
                hotWordTypeName: "",
                placeHolder: ""
            }],
            keyword: this.$store.state.keyWord
        };
    },

    created: function created() {
        this.getHotWord();
    },
    methods: {
        getHotWord: function getHotWord() {
            var _this = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].getHotWord).then(function (response) {
                if (response.data.status == "SUCCESS" && response.data.result.length > 0) {
                    _this.searchHolder = response.data.result;
                    var path = _this.$route.path.toLocaleLowerCase();
                    var pathType = "index";
                    if (path.indexOf("doctor") > 0) {
                        pathType = "doctor";
                    } else if (path.indexOf("clinic") > 0) {
                        pathType = "clinic";
                    } else if (path.indexOf("knowledge") > 0) {
                        pathType = "knowledge";
                    } else if (path.indexOf("diseaselist") > 0) {
                        pathType = "diseaselist";
                    } else if (path.indexOf("list") > 0) {
                        pathType = "list";
                    }
                    _this.searchHolder.forEach(function (value, index) {
                        if (value.hotWordTypeName == "综合") {
                            _this.searchHolder[index].placeHolder = "请输入疾病名称，病症名称，药品地址，诊所名称，医生名称";
                            if (pathType == "index") {
                                _this.defaultSearchHolder.placeHolder = "请输入疾病名称，病症名称，药品地址，诊所名称，医生名称";
                                _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                _this.defaultSearchHolder.sorting = value.sorting;
                                _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                            }
                        } else if (value.hotWordTypeName == "诊所") {
                            _this.searchHolder[index].placeHolder = "请输入诊所名称，科室名称、医生名称";
                            if (pathType == "clinic" || pathType == "index") {
                                _this.defaultSearchHolder.placeHolder = "请输入诊所名称，科室名称、医生名称";
                                _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                _this.defaultSearchHolder.sorting = value.sorting;
                                _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                            }
                        } else if (value.hotWordTypeName == "医生") {
                            _this.searchHolder[index].placeHolder = "请输入医生名称，科室名称";
                            if (pathType == "doctor") {
                                _this.defaultSearchHolder.placeHolder = "请输入医生名称，科室名称";
                                _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                _this.defaultSearchHolder.sorting = value.sorting;
                                _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                            }
                        } else if (value.hotWordTypeName == "药品") {
                            _this.searchHolder[index].placeHolder = "请输入药品名称";
                            if (pathType == "knowledge") {
                                _this.defaultSearchHolder.placeHolder = "请输入药品名称";
                                _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                _this.defaultSearchHolder.sorting = value.sorting;
                                _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                            }
                        } else if (value.hotWordTypeName == "疾病") {
                            _this.searchHolder[index].placeHolder = "请输入疾病名称";
                            if (pathType == "diseaselist") {
                                _this.defaultSearchHolder.placeHolder = "请输入疾病名称";
                                _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                _this.defaultSearchHolder.sorting = value.sorting;
                                _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                            }
                        } else if (value.hotWordTypeName == "产品") {
                            _this.searchHolder[index].placeHolder = "请输入产品名称";
                            if (pathType == "list") {
                                _this.defaultSearchHolder.placeHolder = "请输入产品名称";
                                _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                                _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                                _this.defaultSearchHolder.sorting = value.sorting;
                                _this.defaultSearchHolder.targetUrl = value.targetUrl;
                                _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                            }
                        }
                    });
                }
            }).catch(function (error) {
                _this.$Message.error('数据获取失败,请稍后再试!');
            });
        },
        getSearchHolderItem: function getSearchHolderItem() {
            var _this = this;
            _this.searchHolder.forEach(function (value) {
                if (value.hotWordTypeName == _this.defaultSearchHolder.hotWordTypeName) {
                    _this.defaultSearchHolder.placeHolder = value.placeHolder;
                    _this.defaultSearchHolder.hotWordVOList = value.hotWordVOList;
                    _this.defaultSearchHolder.hotWordTypeId = value.hotWordTypeId;
                    _this.defaultSearchHolder.hotWordTypeName = value.hotWordTypeName;
                    _this.defaultSearchHolder.targetUrl = value.targetUrl;
                }
            });
        },
        returnHotWordsLink: function returnHotWordsLink(hotWord) {
            var str = "";
            if (this.defaultSearchHolder.hotWordTypeName == "产品") {
                str = __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].listRoot + "/list/sou" + encodeURIComponent(hotWord);
            } else if (this.defaultSearchHolder.hotWordTypeName == "药品") {
                str = __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/knowledge/sou" + encodeURIComponent(hotWord);
            } else {
                str = __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/" + this.defaultSearchHolder.targetUrl + "/" + window.areaPinyin + "/sou" + encodeURIComponent(hotWord);
            }
            return str;
        },
        goSearch: function goSearch() {
            if ($.trim(this.keyword).length > 0) {
                if (this.defaultSearchHolder.hotWordTypeName == "产品") {
                    window.open(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].listRoot + "/list/sou" + encodeURIComponent($.trim(this.keyword)));
                } else if (this.defaultSearchHolder.hotWordTypeName == "药品") {
                    window.open(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/" + this.defaultSearchHolder.targetUrl + "/sou" + encodeURIComponent($.trim(this.keyword)));
                } else {
                    window.open(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/" + this.defaultSearchHolder.targetUrl + "/" + window.areaPinyin + "/sou" + encodeURIComponent($.trim(this.keyword)));
                }
            }
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "N2jG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NANv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-wrap"},[_c('div',{staticClass:"top-wap-content"},[_c('div',{staticClass:"left"},[_c('ul',[_c('li',{staticClass:"location-area"},[_c('span',{staticClass:"location"},[_c('i'),_vm._v(_vm._s(this.formatCity(_vm.defaultCity))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"city-list"},[_c('div',{staticClass:"city-tab"},_vm._l((_vm.cityShort),function(city,index){return _c('a',{class:_vm.isSelected(index),on:{"click":function($event){_vm.changeCityShort(index)}}},[_vm._v(_vm._s(city))])})),_vm._v(" "),(_vm.cityShortDefault.length > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.defaultCityType == 'city_list'),expression:"defaultCityType == 'city_list'"}],staticClass:"city-short-list"},_vm._l((_vm.cityShortDefault),function(item){return _c('dl',[_c('dt',[_vm._v(_vm._s(item.firstStr))]),_vm._v(" "),_c('dd',_vm._l((item.cities),function(obj){return _c('a',{on:{"click":function($event){_vm.setDefaultCity(obj.areaId, obj.pinyin)}}},[_vm._v(_vm._s(_vm.formatCity(obj.name)))])}))])})):_c('div',{staticClass:"no-cities"},[_vm._v("\n                            暂无城市列表\n                        ")])])]),_vm._v(" "),(!(_vm.userInfo && _vm.userInfo.realName))?_c('li',[_vm._v("\n                    |   欢迎来到万家！请"),_c('a',{staticClass:"login",attrs:{"href":_vm.loginUrl}},[_vm._v("登录")]),_vm._v(" |\n                ")]):_vm._e(),_vm._v(" "),(!(_vm.userInfo && _vm.userInfo.realName))?_c('li',[_c('a',{attrs:{"href":_vm.registerUrl}},[_vm._v("注册")])]):_vm._e(),_vm._v(" "),(_vm.userInfo && _vm.userInfo.realName)?_c('li',[_vm._v("\n                    |   欢迎来到万家  "),_c('a',{attrs:{"href":_vm.userCenter}},[_vm._v(_vm._s(_vm.userInfo.realName))]),_vm._v(" | "),_c('a',{on:{"click":function($event){_vm.logOut()}}},[_vm._v("退出")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('ul',[_c('li',[_c('a',{staticClass:"shoppingCart",attrs:{"href":_vm.shoppingCart}},[_c('i'),_vm._v("购物车"),_c('b',[_vm._v(_vm._s(_vm.$store.state.cartNum))]),_vm._v("件")]),_vm._v(" "),_c('span',[_vm._v("|")])]),_vm._v(" "),_vm._l((_vm.rightLink),function(item,index){return _c('li',[_c('a',{attrs:{"href":item.url}},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('span',[_vm._v("|")])])}),_vm._v(" "),_c('li',{staticClass:"last-link"},[_c('a',{staticClass:"clinic",attrs:{"target":"_blank","href":_vm.clinicRoot}},[_c('b'),_vm._v("\n                        我是诊所\n                        "),_c('i',{staticClass:"arr-down"})]),_vm._v(" "),_c('div',{staticClass:"myClinic"},[_c('a',{attrs:{"target":"_blank","href":_vm.myClinic}},[_vm._v("\n                            登录云诊所\n                        ")])])])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview__ = __webpack_require__("BTaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_assets_index_less__ = __webpack_require__("wcOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_assets_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_assets_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_index__ = __webpack_require__("IcnI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_iview___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */],
    hashbang: false
});

router.beforeEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_4_iview___default.a.LoadingBar.start();
    document.title = "万家医疗|连锁健康服务平台-" + to.meta.title;
    next();
});
router.afterEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_4_iview___default.a.LoadingBar.finish();
});
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    store: __WEBPACK_IMPORTED_MODULE_8__store_index__["a" /* default */],
    el: '#app',
    router: router,
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NSPu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerBar_vue__ = __webpack_require__("LStO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21854a5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footerBar_vue__ = __webpack_require__("jm0R");
function injectStyle (ssrContext) {
  __webpack_require__("jRlB")
  __webpack_require__("6O99")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21854a5f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21854a5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footerBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OfFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_common__ = __webpack_require__("/sA3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isShow: false,
            defaultList: {},
            msgList: [],
            totalCount: 0,
            currentPage: 1
        };
    },

    created: function created() {
        var _this = this;
        var timer = setInterval(function () {
            if (window.user_id == undefined) {} else {
                clearInterval(timer);
                setTimeout(function () {
                    _this.findMessage();
                }, 2000);
            }
        }, 100);
    },
    mounted: function mounted() {},
    methods: {
        prevClick: function prevClick() {
            var _this = this;
            if (_this.currentPage == 1) {
                return;
            } else {
                _this.currentPage = _this.currentPage - 1;
                _this.defaultList = _this.msgList[_this.currentPage - 1];
            }
        },
        nextClick: function nextClick() {
            var _this = this;
            if (_this.currentPage == _this.totalCount) {
                return;
            } else {
                _this.currentPage = _this.currentPage + 1;
                _this.defaultList = _this.msgList[_this.currentPage - 1];
            }
        },
        subStringHide: function subStringHide(str) {
            var str = str.replace(/<a[^>]*>(.*?)<\/a>/g, '');
            var len = 55;
            if (str.length > len) {
                str = str.substring(0, len) + "...";
            }
            return str;
        },
        closeMsgDialog: function closeMsgDialog() {
            this.isShow = false;
        },
        findMessage: function findMessage() {
            if (window.user_id > 0) {
                var _this = this;
                var params = {
                    userId: window.user_id,
                    isRead: "0"
                };
                this.$http.jsonp(__WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].findMessage, {
                    params: params,
                    'jsonp': 'jsonpCallback'
                }).then(function (res) {
                    var messageData = res.data;
                    if (messageData != null && messageData.status != "ERROR" && messageData.errorCode != "E017") {
                        if (messageData.result != null && messageData.result.datas != null && messageData.result.datas.length > 0) {
                            _this.isShow = true;
                            _this.msgList = messageData.result.datas;
                            _this.defaultList = _this.msgList[_this.currentPage - 1];
                            _this.totalCount = messageData.result.totalCount;
                        }
                    }
                }).catch(function () {
                    _this.$Message.error('数据获取失败,请稍后再试!');
                });
            }
        }
    }
});

/***/ }),

/***/ "Pqhb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pageHeaderBar_vue__ = __webpack_require__("N27l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0466fda4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pageHeaderBar_vue__ = __webpack_require__("pdvb");
function injectStyle (ssrContext) {
  __webpack_require__("Z7oH")
  __webpack_require__("/cTu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0466fda4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pageHeaderBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0466fda4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pageHeaderBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QCbB":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function (a) {
    a.fn.scrollLoading = function (b) {
        var c = {
            attr: "data-url",
            container: a(window),
            callback: a.noop
        };
        var d = a.extend({}, c, b || {});
        d.cache = [];
        a(this).each(function () {
            var h = this.nodeName.toLowerCase(),
                g = a(this).attr(d.attr);
            var i = {
                obj: a(this),
                tag: h,
                url: g
            };
            d.cache.push(i)
        });
        var f = function (g) {
            if (a.isFunction(d.callback)) {
                d.callback.call(g.get(0))
            }
        };
        var e = function () {
            var g = d.container.height();
            if (a(window).get(0) === window) {
                contop = a(window).scrollTop() - 200;
            } else {
                contop = d.container.offset().top - 200;
            }
            a.each(d.cache, function (m, n) {
                var p = n.obj,
                    j = n.tag,
                    k = n.url,
                    l, h;
                if (p) {
                    l = p.offset().top - contop, l + p.height() + 200;
                    if ((l >= 0 && l < g) || (h > 0 && h <= g)) {
                        if (k) {
                            if (j === "img") {
                                f(p.attr("src", k))
                            } else {
                                p.load(k, {}, function () {
                                    f(p)
                                })
                            }
                        } else {
                            f(p)
                        }
                        n.obj = null
                    }
                }
            })
        };
        e();
        d.container.bind("scroll", e)
    }
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "Qjqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('simpleHeaderBar',{attrs:{"name":"问题反馈"}}),_vm._v(" "),_c('div',{staticClass:"survey"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"survey-input"},[_c('Form',{ref:"formValidate",staticClass:"survey-box",attrs:{"rules":_vm.ruleValidate,"label-position":"top","model":_vm.formValidate,"label-width":100}},[_c('FormItem',{staticClass:"question-type",attrs:{"label":"反馈类型：","prop":"feedbackType"}},[_c('RadioGroup',{model:{value:(_vm.formValidate.feedbackType),callback:function ($$v) {_vm.$set(_vm.formValidate, "feedbackType", $$v)},expression:"formValidate.feedbackType"}},[_c('Radio',{staticClass:"radio",attrs:{"label":"0"}},[_vm._v("新功能需求")]),_vm._v(" "),_c('Radio',{staticClass:"radio",attrs:{"label":"1"}},[_vm._v("一般咨询")]),_vm._v(" "),_c('Radio',{staticClass:"radio",attrs:{"label":"2"}},[_vm._v("系统问题")]),_vm._v(" "),_c('Radio',{staticClass:"radio",attrs:{"label":"3"}},[_vm._v("投诉建议")])],1)],1),_vm._v(" "),_c('FormItem',{attrs:{"label":"反馈主题：","prop":"title"}},[_c('Input',{attrs:{"placeholder":"请输入反馈主题(50字以内)","maxlength":_vm.maxLength50},model:{value:(_vm.formValidate.title),callback:function ($$v) {_vm.$set(_vm.formValidate, "title", $$v)},expression:"formValidate.title"}})],1),_vm._v(" "),_c('FormItem',{staticClass:"feed-content",attrs:{"label":"反馈内容：","prop":"feedbackContent"}},[_c('Input',{staticClass:"textarea",attrs:{"type":"textarea","autosize":{minRows: 5,maxRows: 10},"placeholder":_vm.feedPlaceHolder,"autofocus":_vm.autoFocus,"maxlength":_vm.maxLength500},on:{"on-change":_vm.watchWords},model:{value:(_vm.formValidate.feedbackContent),callback:function ($$v) {_vm.$set(_vm.formValidate, "feedbackContent", $$v)},expression:"formValidate.feedbackContent"}}),_vm._v(" "),_c('div',{staticClass:"leftWordsCountTips",staticStyle:{"text-align":"right"}},[_vm._v("\n                        还可以输入\n                        "),(_vm.leftWordsCount==0)?_c('span',{staticStyle:{"color":"#ff400a"}},[_vm._v(_vm._s(_vm.leftWordsCount))]):_c('span',[_vm._v(_vm._s(_vm.leftWordsCount))]),_vm._v("\n                        字\n                    ")])],1),_vm._v(" "),_c('FormItem',{staticClass:"img-upload",attrs:{"label":"上传图片","prop":"uploadList"}},[_c('span',{staticClass:"tips"},[_vm._v("（非必填项，可上传5张，上传图片格式为JPG，PNG格式，每张大小2M以内）：")]),_vm._v(" "),_vm._l((_vm.formValidate.uploadList),function(item){return _c('div',{staticClass:"demo-upload-list"},[(item.status === 'finished')?[_c('img',{attrs:{"src":item.url}}),_vm._v(" "),_c('div',{staticClass:"demo-upload-list-cover"},[_c('Icon',{attrs:{"type":"ios-close"},nativeOn:{"click":function($event){_vm.handleRemove(item)}}})],1)]:[(item.showProgress)?_c('Progress',{attrs:{"percent":item.percentage,"hide-info":""}}):_vm._e()]],2)}),_vm._v(" "),_c('Upload',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUploadBtnShow),expression:"isUploadBtnShow"}],ref:"upload",staticStyle:{"display":"inline-block","width":"145px"},attrs:{"show-upload-list":false,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"format":['jpg','jpeg','png'],"max-size":2048,"on-format-error":_vm.handleFormatError,"on-exceeded-size":_vm.handleMaxSize,"before-upload":_vm.handleBeforeUpload,"type":"drag","action":_vm.imgUpload}},[_c('div',{staticStyle:{"width":"145px","height":"110px","line-height":"130px"}},[_c('Icon',{attrs:{"type":"camera","size":"50"}})],1)])],2),_vm._v(" "),_c('FormItem',{staticClass:"hospital-title",attrs:{"label":"相关医疗机构名称","prop":"hospitalTitle"}},[_c('span',{staticClass:"tips"},[_vm._v("（若有请填写）：")]),_vm._v(" "),_c('Input',{attrs:{"placeholder":"请输入相关医疗机构名称","maxlength":_vm.maxLength50},model:{value:(_vm.formValidate.hospitalTitle),callback:function ($$v) {_vm.$set(_vm.formValidate, "hospitalTitle", $$v)},expression:"formValidate.hospitalTitle"}})],1),_vm._v(" "),_c('FormItem',{staticClass:"short-label",attrs:{"label":"联系人姓名：","prop":"contactName"}},[_c('Input',{attrs:{"placeholder":"请输入联系人姓名","maxlength":_vm.maxLength20},model:{value:(_vm.formValidate.contactName),callback:function ($$v) {_vm.$set(_vm.formValidate, "contactName", $$v)},expression:"formValidate.contactName"}})],1),_vm._v(" "),_c('FormItem',{staticClass:"short-label",attrs:{"label":"联系电话：","maxlength":_vm.maxLength12,"prop":"contactPhone"}},[_c('Input',{attrs:{"placeholder":"请输入您的手机号或固定电话号码(例：021-xxxxxxxx)"},model:{value:(_vm.formValidate.contactPhone),callback:function ($$v) {_vm.$set(_vm.formValidate, "contactPhone", $$v)},expression:"formValidate.contactPhone"}})],1),_vm._v(" "),_c('p',[_vm._v("\n                    感谢您的反馈，我们会尽快处理，谢谢！\n                ")]),_vm._v(" "),_c('div',{staticClass:"btn"},[_c('Button',{staticClass:"btn-submit",attrs:{"type":"primary","loading":_vm.loading},on:{"click":function($event){_vm.handleSubmit('formValidate')}}},[(!_vm.loading)?_c('span',[_vm._v("提交")]):_c('span',[_vm._v("Loading...")])])],1)],1)],1)]),_vm._v(" "),_c('simpleFooterBar'),_vm._v(" "),_c('Modal',{staticClass:"dialog-msg",attrs:{"mask-closable":false,"scrollable":true,"closable":false},on:{"on-ok":function($event){_vm.handleReset('formValidate')}},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('p',[_vm._v("\n            已收到您的反馈"),_c('br'),_vm._v("\n            稍后会有工作人员跟你联系~！\n        ")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-header"},[_vm._v("\n            感谢您对万家医疗的支持，"),_c('span',[_vm._v("请在此说明您要反馈的内容，后续我们将安排专人处理您的反馈。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QrfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    详情\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sw/4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TNvR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "URsM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ufbt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"bird"}),_vm._v(" "),_c('div',{staticClass:"function"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('a',{staticClass:"ewm"},[_c('i'),_vm._v(" "),_c('div',{staticClass:"hover-box ewm-hover"},[_c('b',{staticClass:"arr"}),_vm._v(" "),_c('img',{attrs:{"src":_vm.ewm,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"txt2"},[_vm._v("")])])]),_vm._v(" "),_c('a',{staticClass:"feedback",attrs:{"target":"_blank","href":_vm.feedBack}},[_c('i'),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('a',{staticClass:"top-scroll",on:{"click":function($event){_vm.scrollTop()}}},[_c('i')])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"kf",attrs:{"target":"_blank","href":"http://www.jk.cn/im-cs-m/#/nav?entranceId=61976780206"}},[_c('i'),_vm._v(" "),_c('div',{staticClass:"hover-box kf-hover"},[_c('b',{staticClass:"arr"}),_vm._v(" "),_c('b',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"txt1"},[_vm._v("点击在线咨询")]),_vm._v(" "),_c('div',{staticClass:"txt2"},[_vm._v("快速高效与您沟通")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"hot-line"},[_c('i'),_vm._v(" "),_c('div',{staticClass:"hover-box line-hover"},[_c('b',{staticClass:"arr"}),_vm._v(" "),_c('b',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"txt1"},[_vm._v("全国服务热线")]),_vm._v(" "),_c('div',{staticClass:"txt2"},[_vm._v("400-931-6788")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hover-box feedback-hover"},[_c('b',{staticClass:"arr"}),_vm._v(" "),_c('b',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"txt1"},[_vm._v("点击反馈问题")]),_vm._v(" "),_c('div',{staticClass:"txt2"},[_vm._v("专人为您解决问题")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    keyWord: function keyWord(state) {
        return state.keyWord;
    }
});

/***/ }),

/***/ "V5z6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_url__ = __webpack_require__("FKvS");
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        width: {
            type: String,
            default: "500px"
        },
        height: {
            type: String,
            default: "500px"
        }
    },
    data: function data() {
        return {
            loadingImg: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].static + "/img/wj-loading.gif",
            style: 'width: ' + this.width + '; height: ' + this.height + ';line-height: ' + this.height + ';'
        };
    },

    created: function created() {},
    mounted: function mounted() {},
    methods: {}
});

/***/ }),

/***/ "VpaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_pageTopBar__ = __webpack_require__("LX8p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_pageHeaderBar__ = __webpack_require__("Pqhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_sideBar__ = __webpack_require__("nCrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_footerBar__ = __webpack_require__("NSPu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Common_LoginDialog__ = __webpack_require__("3ZqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils_loadingBar__ = __webpack_require__("EWI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Common_menuBar__ = __webpack_require__("XRHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_utils_scrollLoading__ = __webpack_require__("QCbB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_js_utils_scrollLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_js_utils_scrollLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Common_msgDialog__ = __webpack_require__("/Lvd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_js_common__ = __webpack_require__("/sA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        PageTopBar: __WEBPACK_IMPORTED_MODULE_1__Common_pageTopBar__["a" /* default */],
        LoadingBar: __WEBPACK_IMPORTED_MODULE_6__Utils_loadingBar__["a" /* default */],
        SideBar: __WEBPACK_IMPORTED_MODULE_3__Common_sideBar__["a" /* default */],
        pageHeaderBar: __WEBPACK_IMPORTED_MODULE_2__Common_pageHeaderBar__["a" /* default */],
        FooterBar: __WEBPACK_IMPORTED_MODULE_4__Common_footerBar__["a" /* default */],
        MenuBar: __WEBPACK_IMPORTED_MODULE_7__Common_menuBar__["a" /* default */],
        MsgDialog: __WEBPACK_IMPORTED_MODULE_10__Common_msgDialog__["a" /* default */],
        LoginDialog: __WEBPACK_IMPORTED_MODULE_5__Common_LoginDialog__["a" /* default */]
    },
    data: function data() {
        return {
            webRoot: __WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].commonRoot,
            districtList: [],
            departmentsList: [],
            hospitalQualification: [{ //医院资质
                name: "不限",
                isSelected: true
            }, {
                name: "万家认证",
                code: 1
            }, {
                name: "医保",
                code: 2
            }, {
                name: "万家联盟",
                code: 3
            }, {
                name: "商保",
                code: 4
            }],
            totalCount: 0,
            pageSize: 10,
            pageNo: parseInt(this.$route.query.pageNo) || 1,
            searchLoading: true,
            clinicListData: [],
            nginxRoot: window.nginxRoot,
            fitProduct: [],
            defaultClinicImg: 'this.src="https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419"',
            defaultErrorImg: "this.src='" + __WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].static + "/img/errorImg.jpg'",
            listShow: false,
            areaShow: false,
            departShow: false
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["b" /* mapMutations */])(['setKeyWord']), {
        initData: function initData() {
            this.setKeyWord();
            this.getDistrictList();
            this.getDepartmentsList();
            this.getFitProduct();
            //                this.clinicList()
        },

        //选中的样式
        returnClassName: function returnClassName(index, isSelected) {
            if (index == 0) {
                if (isSelected) {
                    return "first-label ivu-checkbox-wrapper  ivu-checkbox-wrapper-checked";
                } else {
                    return "first-label ivu-checkbox-wrapper";
                }
            } else {
                if (isSelected) {
                    return "ivu-checkbox-wrapper  ivu-checkbox-wrapper-checked";
                } else {
                    return "ivu-checkbox-wrapper";
                }
            }
        },
        changePage: function changePage(pageIndex) {
            this.pageNo = pageIndex;
            this.clinicList();
            $('body,html').animate({
                scrollTop: $('#list-box').offset().top - 10
            }, 0);
            return false;
        },
        appointmentImm: function appointmentImm(id) {
            return window.commonRoot + "/clinic/detail" + "/" + id;
        },

        //区域选择
        getNewDist: function getNewDist(index, areaId, isSelected) {
            var _this = this;

            if (isSelected == "undefined") {
                isSelected = false;
            }
            //点击不限
            if (index == 0) {
                if (isSelected) {
                    return;
                } else {
                    this.districtList.forEach(function (item, i) {
                        if (i > 0) {
                            _this.districtList[i]["isSelected"] = false;
                        }
                    });
                    this.districtList[0]["isSelected"] = true;
                }
            } else {
                if (isSelected) {
                    var len = 0;
                    this.districtList.forEach(function (item, i) {
                        if (i > 0 && item.isSelected) {
                            len++;
                        }
                    });
                    if (len == 1) {
                        this.districtList[0]["isSelected"] = true;
                    }
                    this.districtList[index]["isSelected"] = false;
                } else {
                    this.districtList[0]["isSelected"] = false;
                    this.districtList[index]["isSelected"] = true;
                }
            }

            //初始化pageNo
            this.pageNo = 1;
            this.$forceUpdate();
            this.clinicList();
        },

        //科室选择
        getNewDep: function getNewDep(index, isSelected) {
            var _this2 = this;

            if (isSelected == "undefined") {
                isSelected = false;
            }
            //点击不限
            if (index == 0) {
                if (isSelected) {
                    return;
                } else {
                    this.departmentsList.forEach(function (item, i) {
                        if (i > 0) {
                            _this2.departmentsList[i]["isSelected"] = false;
                        }
                    });
                    this.departmentsList[0]["isSelected"] = true;
                }
            } else {
                if (isSelected) {
                    var len = 0;
                    this.departmentsList.forEach(function (item, i) {
                        if (i > 0 && item.isSelected) {
                            len++;
                        }
                    });
                    if (len == 1) {
                        this.departmentsList[0]["isSelected"] = true;
                    }
                    this.departmentsList[index]["isSelected"] = false;
                } else {
                    this.departmentsList[0]["isSelected"] = false;
                    this.departmentsList[index]["isSelected"] = true;
                }
            }

            //初始化pageNo

            this.pageNo = 1;
            this.$forceUpdate();
            this.clinicList();
        },

        //医院资质选择
        getNewHospital: function getNewHospital(index, isSelected) {
            var _this3 = this;

            if (isSelected == "undefined") {
                isSelected = false;
            }
            //点击不限
            if (index == 0) {
                if (isSelected) {
                    return;
                } else {
                    this.hospitalQualification.forEach(function (item, i) {
                        if (i > 0) {
                            _this3.hospitalQualification[i]["isSelected"] = false;
                        }
                    });
                    this.hospitalQualification[0]["isSelected"] = true;
                }
            } else {
                if (isSelected) {
                    var len = 0;
                    this.hospitalQualification.forEach(function (item, i) {
                        if (i > 0 && item.isSelected) {
                            len++;
                        }
                    });
                    if (len == 1) {
                        this.hospitalQualification[0]["isSelected"] = true;
                    }
                    this.hospitalQualification[index]["isSelected"] = false;
                } else {
                    this.hospitalQualification[0]["isSelected"] = false;
                    this.hospitalQualification[index]["isSelected"] = true;
                }
            }

            //初始化pageNo
            this.pageNo = 1;
            this.$forceUpdate();
            this.clinicList();
        },

        //获取区域list
        getDistrictList: function getDistrictList() {
            var _this4 = this;

            var params = {
                cityCode: window.areaId
            };
            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].districtList, {
                params: params
            }).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    _this4.districtList = [{
                        name: "不限",
                        areaId: 0,
                        isSelected: true
                    }];
                    _this4.districtList = _this4.districtList.concat(res.result);
                }
            }).catch(function () {
                console.log('数据获取失败,请稍后再试!');
            });
        },

        //科室list
        getDepartmentsList: function getDepartmentsList() {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].department).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    //获取url的科室Id 如果存在则标亮 TODO内测一下
                    var deId = '';
                    var path_arr = window.location.href.split("/");
                    path_arr.forEach(function (item) {
                        if (item.indexOf("DPT") > -1) {
                            deId = item;
                        }
                    });

                    if (deId) {
                        _this5.departmentsList = [{
                            departmentName: "不限",
                            isSelected: false
                        }];

                        res.result.forEach(function (item, index) {
                            if (index > 0 && item.departmentId == deId) {
                                res.result[index].isSelected = true;
                            }
                        });

                        _this5.departmentsList = _this5.departmentsList.concat(res.result);
                        _this5.searchLoading = true;
                        _this5.clinicList();
                        return;
                    }

                    _this5.departmentsList = [{
                        departmentName: "不限",
                        isSelected: true
                    }];

                    _this5.departmentsList = _this5.departmentsList.concat(res.result);
                    _this5.clinicList();
                }
            }).catch(function (err) {
                console.log('数据获取失败,请稍后再试!');
            });
        },

        //根据条件展示列表数据
        clinicList: function clinicList() {
            var _this6 = this;

            var dist = [];
            var departments = [];
            var qualifications = [];
            // 获取选中区域参数;
            this.districtList.forEach(function (item, index) {
                if (index > 0 && item.isSelected) {
                    dist.push(item.areaId);
                }
            });

            this.departmentsList.forEach(function (item, index) {
                if (index > 0 && item.isSelected) {
                    departments.push(item.departmentId);
                }
            });

            this.hospitalQualification.forEach(function (item, index) {
                if (index > 0 && item.isSelected) {
                    qualifications.push(item.code);
                }
            });

            var params = {
                cityCode: window.areaId,
                pageSize: this.pageSize,
                pageNo: this.pageNo,
                districtCode: dist.join(','),
                deptIds: departments.join(','),
                keyWords: this.keyWord,
                qualifications: qualifications.join(',')
            };

            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].clinicPage, {
                params: params
            }).then(function (res) {
                if (res.data.status == "SUCCESS" && res.data.result != null && res.data.result.results != null) {
                    _this6.listShow = true;
                    _this6.searchLoading = false;
                    _this6.totalCount = res.data.result.totalCount;
                    _this6.clinicListData = res.data.result.results;
                }
            }).catch(function () {
                _this6.searchLoading = false;
                console.log('数据获取失败,请稍后再试!');
            });
        },
        getFitProduct: function getFitProduct() {
            var _this7 = this;

            var params = {
                cityCode: window.areaId
            };
            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].getRecomentProduct, {
                params: params
            }).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    _this7.fitProduct = res.result;
                }
            }).catch(function (error) {
                console.log(error, '数据获取失败,请稍后再试!');
            });
        },
        judgeLogin: function judgeLogin() {
            var userInfo = this.$store.state.userInfo;
            if (userInfo != null && userInfo.userId > 0) {
                return true;
            } else {
                //this.$store.commit('changeShowLoginDialogState');
                window.location.href = __WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].loginUrl;
                return false;
            }
        },


        //点击关注按钮
        followFun: function followFun(id, index) {
            var _this8 = this;

            var flag = this.judgeLogin();
            if (flag) {
                var params = {
                    clinicId: id
                };
                __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].insertClinicConcern, {
                    params: params
                }).then(function (response) {
                    var res = response.data;
                    if (res.status == "SUCCESS") {
                        _this8.clinicListData[index].isConcern = '1';
                    }
                }).catch(function (error) {
                    _this8.$Message.error(error, '数据获取失败,请稍后再试!');
                });
            }
        },

        //取消关注按钮
        unfollowFun: function unfollowFun(id, index) {
            var _this9 = this;

            var params = {
                clinicId: id
            };
            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_11__config_url__["a" /* default */].deleteClinicConcern, {
                params: params
            }).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    _this9.clinicListData[index].isConcern = false;
                }
            }).catch(function (error) {
                _this9.$Message.error(error, '数据获取失败,请稍后再试!');
            });
        },
        loginSuccessCallBack: function loginSuccessCallBack() {
            //登陆成功之后的操作
            this.$forceUpdate();
            this.clinicList();
        },
        returnImgPath: function returnImgPath(path, root, type) {
            if (type == "middle") {
                if (path != null && path.length > 0) {
                    return root + "/middle/" + path;
                } else {
                    return "https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419";
                    //return url.static + '/img/clinicDefault.jpg'
                }
            } else {
                if (path != null && path.length > 0) {
                    return root + path;
                } else {
                    return "https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419";
                }
            }
        },
        areaMore: function areaMore() {
            if (!this.areaShow) {
                this.areaShow = true;
                $("#clinic-area").css({
                    "height": "auto"
                });
                $("#area-triangle").removeClass('triangle-down');
                $("#area-triangle").addClass('triangle-up');
            } else {
                this.areaShow = false;
                $("#clinic-area").css({
                    "height": "55px"
                });
                $("#area-triangle").removeClass('triangle-up');
                $("#area-triangle").addClass('triangle-down');
            }
        },
        departMore: function departMore() {
            if (!this.departShow) {
                this.departShow = true;
                $("#clinic-depart").css({
                    "height": "auto"
                });
                $("#depart-triangle").removeClass('triangle-down');
                $("#depart-triangle").addClass('triangle-up');
            } else {
                this.departShow = false;
                $("#clinic-depart").css({
                    "height": "55px"
                });
                $("#depart-triangle").removeClass('triangle-up');
                $("#depart-triangle").addClass('triangle-down');
            }
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["c" /* mapGetters */])(['keyWord'])),
    created: function created() {
        this.initData();
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "XEa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_common__ = __webpack_require__("/sA3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            loginUrl: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].loginUrl,
            registerUrl: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].registerUrl,
            defaultSelectIndex: 0,
            defaultCityType: "city_list",
            userCenter: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].hyqtRoot,
            flag: true,
            cityShortDefault: [],
            cartNum: 0,
            cityShortA_F: [],
            cityShortG_J: [],
            cityShortK_Q: [],
            cityShortR_W: [],
            cityShortX_Z: [],
            cookieTime: 365,
            shoppingCart: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].cartRoot,
            clinicRoot: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].clinicRoot,
            myClinic: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].myClinic,
            cityShort: ['ABCDEF', 'GHIJ', 'KLMNOPQ', 'RSTUVW', 'XYZ'],
            rightLink: [{
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].hyqtRoot,
                title: "我的万家"
            }, {
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].busRoot + "/open/activity",
                title: "企业服务"
            }, {
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/help",
                title: "帮助中心"
            }, {
                url: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/appDownload",
                title: "手机万家"
            }]

        };
    },

    created: function created() {
        this.getLocationList();
        this.$store.dispatch("getCartNum");
        this.$store.dispatch("getUserInfo");
    },
    computed: {
        userInfo: function userInfo() {
            return this.$store.state.userInfo;
        },
        defaultCity: function defaultCity() {
            return this.$store.state.defaultCity;
        }
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].delCookie("areaId");
        __WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].delCookie("areaPinyin");
        __WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].setCookie("areaId", window.areaId, this.cookieTime); //默认上海
        __WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].setCookie("areaPinyin", window.areaPinyin, this.cookieTime);
    },
    methods: {
        logOut: function logOut() {
            window.location.href = __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + '/login/logout.do?targeturl=' + encodeURI(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].casRoot + '/logout?service=' + window.location.href);
        },

        //去除 "市"
        formatCity: function formatCity(city) {
            return city.replace("市", "");
        },

        // 设置默认城市
        setDefaultCity: function setDefaultCity(areaId, pinyin) {
            var _this = this;
            var params = {
                areaId: areaId
            };
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].checkCitysiteAndGetCity, {
                params: params
            }).then(function (response) {
                var res = response.data.result;
                if (parseInt(areaId) == parseInt(res.areaId)) {
                    __WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].setCookie("areaId", areaId, _this.cookieTime);
                    __WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].setCookie("areaPinyin", pinyin, _this.cookieTime);
                    if (_this.$route.name == "Doctor") {
                        window.location = "/doctor";
                    } else if (_this.$route.name == "Clinic") {
                        window.location = "/clinic";
                    } else {
                        window.location = "/" + pinyin;
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].setCookie("areaId", res.areaId, _this.cookieTime);
                    __WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].setCookie("areaPinyin", res.pinyin, _this.cookieTime);
                    if (_this.$route.name == "Doctor") {
                        window.location = "/doctor";
                    } else if (_this.$route.name == "Clinic") {
                        window.location = "/clinic";
                    } else {
                        window.location = "/" + pinyin;
                    }
                }
            }).catch(function () {
                _this.$Message.error('数据获取失败,请稍后再试!');
            });
        },
        changeCityShort: function changeCityShort(index) {
            this.defaultSelectIndex = index;
            switch (index) {
                case 0:
                    this.defaultCityType = "city_list";
                    this.cityShortDefault = this.cityShortA_F;
                    break;
                case 1:
                    this.defaultCityType = "city_list";
                    this.cityShortDefault = this.cityShortG_J;
                    break;
                case 2:
                    this.defaultCityType = "city_list";
                    this.cityShortDefault = this.cityShortK_Q;
                    break;
                case 3:
                    this.defaultCityType = "city_list";
                    this.cityShortDefault = this.cityShortR_W;
                    break;
                case 4:
                    this.defaultCityType = "city_list";
                    this.cityShortDefault = this.cityShortX_Z;
                    break;
            }
        },
        isSelected: function isSelected(index) {
            if (index == this.defaultSelectIndex) {
                return "selected";
            }
        },
        getLocationList: function getLocationList() {
            var _this = this;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].getOpenCitySite).then(function (response) {
                var locationList = response.data.result;
                if (locationList != null && locationList instanceof Array && locationList.length > 0) {
                    _this.locationList = locationList;
                    _this.locationList.forEach(function (item) {
                        item.cities.forEach(function (list) {
                            if (parseInt(list.areaId) == parseInt(window.areaId)) {
                                _this.$store.dispatch("getDefaultCity", list.name);
                            }
                        });
                        if (item.firstStr == "A" || item.firstStr == "B" || item.firstStr == "C" || item.firstStr == "D" || item.firstStr == "F") {
                            _this.cityShortA_F.push(item);
                            _this.cityShortDefault = _this.cityShortA_F;
                        }
                        if (item.firstStr == "G" || item.firstStr == "H" || item.firstStr == "I" || item.firstStr == "J") {
                            _this.cityShortG_J.push(item);
                        }
                        if (item.firstStr == "K" || item.firstStr == "L" || item.firstStr == "M" || item.firstStr == "N" || item.firstStr == "O" || item.firstStr == "P" || item.firstStr == "Q") {
                            _this.cityShortK_Q.push(item);
                        }
                        if (item.firstStr == "R" || item.firstStr == "S" || item.firstStr == "T" || item.firstStr == "U" || item.firstStr == "V" || item.firstStr == "W") {
                            _this.cityShortR_W.push(item);
                        }
                        if (item.firstStr == "X" || item.firstStr == "Y" || item.firstStr == "Z") {
                            _this.cityShortX_Z.push(item);
                        }
                    });
                }
            }).catch(function (error) {
                _this.$Message.error('数据获取失败，请稍后再试!');
            });
        }
    }
});

/***/ }),

/***/ "XPqd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XRHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menuBar_vue__ = __webpack_require__("3+jo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d2d4293_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menuBar_vue__ = __webpack_require__("Mimf");
function injectStyle (ssrContext) {
  __webpack_require__("MPMi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d2d4293"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menuBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d2d4293_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menuBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YEZN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-page"},[_c('PageTopBar'),_vm._v(" "),_c('pageHeaderBar'),_vm._v(" "),_c('SideBar'),_vm._v(" "),_c('MenuBar'),_vm._v(" "),_c('div',{staticClass:"grey-body"},[_c('div',{staticClass:"list-bread"},[_c('a',{attrs:{"href":_vm.webRoot}},[_vm._v("首页")]),_vm._v(" "),_c('span',[_vm._v(">")]),_vm._v(" "),_c('a',[_vm._v("医生列表")])]),_vm._v(" "),_c('div',{staticClass:"list-body doctor-list"},[_c('div',{staticClass:"search-area"},[_c('ul',[_c('li',{staticClass:"more-list",attrs:{"id":"doctor-area"}},[_c('span',{staticClass:"area-txt"},[_vm._v("区       域：")]),_vm._v(" "),_c('div',{staticClass:"search-list list limited dist"},[_vm._l((_vm.districtList),function(item,index){return _c('label',{class:_vm.returnClassName(index, item.isSelected),attrs:{"data-index":index,"title":item.name},on:{"click":function($event){_vm.getNewDist(index, item.areaId,item.isSelected)}}},[_c('p',[_vm._v(_vm._s(item.name))])])}),_vm._v(" "),(_vm.districtList.length > 10)?_c('div',{staticClass:"de-more",on:{"click":_vm.areaMore}},[_vm._v("\n                                更多\n                                "),_c('div',{staticClass:"triangle triangle-down",attrs:{"id":"area-triangle"}})]):_vm._e()],2)]),_vm._v(" "),_c('li',{staticClass:"more-list",attrs:{"id":"doctor-depart"}},[_c('span',{staticClass:"area-txt"},[_vm._v("科       室：")]),_vm._v(" "),_c('div',{staticClass:"search-list list limited"},[_vm._l((_vm.departmentsList),function(item,index){return _c('label',{class:_vm.returnClassName(index, item.isSelected),attrs:{"data-index":index,"title":item.departmentName},on:{"click":function($event){_vm.getNewDep(index, item.isSelected)}}},[_c('p',[_vm._v("\n                                "+_vm._s(item.departmentName))])])}),_vm._v(" "),(_vm.departmentsList.length > 10)?_c('div',{staticClass:"de-more",on:{"click":_vm.departMore}},[_vm._v("\n                                更多\n                                "),_c('div',{staticClass:"triangle triangle-down",attrs:{"id":"depart-triangle"}})]):_vm._e()],2)]),_vm._v(" "),_c('li',[_c('span',{staticClass:"area-txt"},[_vm._v("职       称：")]),_vm._v(" "),_c('div',{staticClass:"search-list list limited"},_vm._l((_vm.jobTitle),function(item,index){return _c('label',{class:_vm.returnClassName(index, item.isSelected),attrs:{"data-index":index,"title":item.dictDescription},on:{"click":function($event){_vm.getJobtit(index, item.isSelected)}}},[_c('p',[_vm._v("\n                                "+_vm._s(item.dictDescription))])])}))])])]),_vm._v(" "),(_vm.searchLoading)?_c('LoadingBar',{attrs:{"height":"120px"}}):_vm._e(),_vm._v(" "),(_vm.listShow)?_c('div',{staticClass:"list-content clearfix",attrs:{"id":"list-box"}},[_c('div',{staticClass:"list-left recommed-doctor"},[_c('div',{staticClass:"doctor-list-item"},[_vm._l((_vm.doctorListData),function(item,index){return (_vm.doctorListData.length>0)?[_c('div',{staticClass:"clinic-groom clearfix"},[_c('a',{staticClass:"doc-portrait",attrs:{"href":_vm.appointmentImm(item.id)}},[(item.doctorPhoto)?_c('img',{staticClass:"doc-img",attrs:{"src":_vm.returnDoctorLog(item.doctorPhoto),"onerror":_vm.defaultErrorImg,"alt":""}}):_c('img',{staticClass:"doc-img",attrs:{"src":_vm.defaultErrorImg,"onerror":_vm.defaultErrorImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"doc-list"},[_c('ul',[_c('li',[_c('h1',{staticClass:"doctor-name"},[_c('a',{attrs:{"href":_vm.appointmentImm(item.id)}},[_vm._v(_vm._s(item.doctorName))])]),_vm._v(" "),(item.medicineTitle && item.medicineTitle != '医师')?_c('span',{staticStyle:{"position":"relative","top":"-3px","font-size":"12px","padding":"0 3px","color":"#259bef","border":"1px solid #259bef","margin":"0 0 12px 8px","border-radius":"2px"}},[_vm._v(_vm._s(item.medicineTitle))]):_vm._e()]),_vm._v(" "),_c('li',[_c('p',[_vm._v(_vm._s(item.diagnosisType1))])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("从业经验：未录入")]),_vm._v(" "),(item.practiceBeginDate)?_c('p',[_vm._v("\n                                                从业经验："),_c('span',[_vm._v(_vm._s(_vm._f("workingTime")(item.practiceBeginDate))+"年以上")])]):_vm._e()]),_vm._v(" "),_c('li',[_c('p',{staticStyle:{"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_vm._v("\n                                                擅        长："+_vm._s(item.goodArea))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.returnClinicHref(item.clinicId)}},[_c('p',{staticStyle:{"float":"left"}},[_vm._v("诊        所：")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#259bef","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_vm._v(_vm._s(item.clinicName))])])])])]),_vm._v(" "),_c('div',{staticClass:"operating"},[(item.isConcern)?_c('div',{staticClass:"btn-follow",on:{"click":function($event){_vm.unfollowFun(item.id,index)}}},[_c('span',{staticClass:"follow"}),_c('em',[_vm._v("已关注")])]):_vm._e(),_vm._v(" "),(!item.isConcern)?_c('div',{staticClass:"btn-follow",on:{"click":function($event){_vm.followFun(item.id,index)}}},[_c('span',{staticClass:"unfollow"}),_c('em',[_vm._v("立即关注")])]):_vm._e(),_vm._v(" "),(item.clinic && item.linic.openingTime)?_c('p',{staticClass:"timeplan"},[_vm._v("\n                                        "+_vm._s(item.workingTime))]):_c('p',{staticClass:"timeplan"},[_vm._v("周一至周日  上午8:00-下午10:00")]),_vm._v(" "),_c('a',{staticClass:"btn-reserve",attrs:{"href":_vm.appointmentImm(item.id)}},[_vm._v("立即预约")])])])]:_vm._e()})],2),_vm._v(" "),(_vm.doctorListData.length==0)?_c('div',{staticClass:"no-match"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.totalCount)?_c('Page',{staticClass:"list-page",attrs:{"total":_vm.totalCount,"current":_vm.pageNo,"page-size":_vm.pageSize},on:{"on-change":_vm.changePage}}):_vm._e()],1),_vm._v(" "),(_vm.recommendClinic.length > 0)?_c('div',{staticClass:"list-right"},[_c('h1',[_vm._v("推荐诊所")]),_vm._v(" "),_c('ul',_vm._l((_vm.recommendClinic),function(item,index){return _c('li',[_c('a',{attrs:{"href":_vm.returnClinicHref(item.clinicId)}},[_c('div',{staticClass:"pro-img"},[_c('img',{attrs:{"src":_vm.nginxRoot + item.clinicFacadeName,"onerror":_vm.defaultClinicImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"pro-name"},[_vm._v(_vm._s(item.clinicName))])])])}))]):_vm._e()]):_vm._e()],1)]),_vm._v(" "),_c('FooterBar'),_vm._v(" "),_c('MsgDialog'),_vm._v(" "),_c('LoginDialog',{on:{"on-success":_vm.loginSuccessCallBack}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('i'),_vm._v("未搜索到符合条件的医生")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Test_Hello_vue__ = __webpack_require__("dZcn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Index_index_vue__ = __webpack_require__("zv4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Survey_index_vue__ = __webpack_require__("udc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Survey_reply_vue__ = __webpack_require__("Gcla");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Clinic_list_vue__ = __webpack_require__("mT9D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Doctor_list_vue__ = __webpack_require__("ADR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Clinic_detail_vue__ = __webpack_require__("GPws");








var routes = [{
    path: '/Hello',
    name: 'Hello',
    meta: {
        title: "这是测试页面"
    },
    component: __WEBPACK_IMPORTED_MODULE_0__components_Test_Hello_vue__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
        next();
    }
}, {
    path: '/',
    name: 'Index',
    meta: {
        title: "首页"
    },
    component: __WEBPACK_IMPORTED_MODULE_1__components_Index_index_vue__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
        next();
    }
}, {
    path: '/doctor*',
    name: 'Doctor',
    meta: {
        title: "医生"
    },
    component: __WEBPACK_IMPORTED_MODULE_5__components_Doctor_list_vue__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
        next();
    }
}, {
    path: '/clinic*',
    name: 'Clinic',
    meta: {
        title: "诊所"
    },
    component: __WEBPACK_IMPORTED_MODULE_4__components_Clinic_list_vue__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
        next();
    }
}, {
    path: '/list*',
    name: 'Doctor',
    meta: {
        title: "Doctor"
    },
    component: __WEBPACK_IMPORTED_MODULE_1__components_Index_index_vue__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
        next();
    }
}, {
    path: '/sso/feedback',
    name: 'feedback',
    meta: {
        title: "问题反馈"
    },
    component: __WEBPACK_IMPORTED_MODULE_2__components_Survey_index_vue__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
        next();
    }
}, {
    path: "/sso/feedback/reply",
    meta: {
        title: "问题反馈"
    },
    name: 'reply',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Survey_reply_vue__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
        next();
    }
},
/*{
    path: '/doctor/:city',
    name: 'Doctor',
    meta:{
        title:"Doctor",
    },
    component: Doctor,
    beforeEnter: (to, from, next) => {
        next();
    },
},
{
    path: '/doctor/:id',
    name: 'Doctor',
    meta:{
        title:"Doctor",
    },
    component: Doctor,
    beforeEnter: (to, from, next) => {
        next();
    },
},
{
    path: '/doctor/:city/:id',
    name: 'Doctor',
    meta:{
        title:"Doctor",
    },
    component: Doctor,
    beforeEnter: (to, from, next) => {
        next();
    },
},*/
{
    path: '/:city',
    name: 'Index',
    meta: {
        title: "首页"
    },
    component: __WEBPACK_IMPORTED_MODULE_1__components_Index_index_vue__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
        next();
    }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "Z7oH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bEVD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cfYE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dFcR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dZcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_550802ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("jlGn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_550802ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eOkT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_url__ = __webpack_require__("FKvS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        name: {
            type: String,
            default: ""
        }
    },
    data: function data() {
        return {
            ewm: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].static + "/img/wx-ewm.jpg",
            logo: __WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].static + "/img/wanjia-logo.png"
        };
    }
});

/***/ }),

/***/ "h3en":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-page-top"},[_c('div',{staticClass:"page-top-container"},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":_vm.logo,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('span',{staticClass:"txt1"},[_vm._v("服务热线：")]),_vm._v(" "),_c('span',{staticClass:"phone-number"},[_vm._v("400-931-6788")]),_vm._v(" "),_c('span',{staticClass:"line"}),_vm._v(" "),_c('a',{staticClass:"wx-logo",attrs:{"href":"javascript:;"}},[_c('i'),_vm._v(" "),_c('div',{staticClass:"ewm-box"},[_c('img',{attrs:{"src":_vm.ewm,"alt":""}}),_vm._v(" "),_c('p',[_vm._v("\n                        万家微信服务号\n                    ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h6yn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hYnn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoginDialog),expression:"isShowLoginDialog"}],staticClass:"login-dialog-box"},[_c('div',{staticClass:"login-dialog-mask"}),_vm._v(" "),_c('div',{staticClass:"login-dialog"},[_c('a',{staticClass:"login-dialog-close",on:{"click":_vm.closeLoginDialog}}),_vm._v(" "),_c('ul',{staticClass:"way-tab"},_vm._l((_vm.title),function(item,index){return _c('li',{class:item.isSelected ? 'current': '',on:{"click":function($event){_vm.changeTabShow(index)}}},[_vm._v(_vm._s(item.name)+"\n            ")])})),_vm._v(" "),_c('div',{staticClass:"login-dialog-content"},[(_vm.isShowTab1)?_c('div',{staticClass:"password-login-box"},[_c('div',{staticClass:"msgTips"},[(_vm.isTab1Success && _vm.isShowTip1)?_c('div',{staticClass:"successTips"},[_c('i'),_vm._v(" "),_c('span',[_vm._v("\n                            "+_vm._s(this.tipMsg1)+"\n                        ")])]):_vm._e(),_vm._v(" "),(!_vm.isTab1Success && _vm.isShowTip1)?_c('div',{staticClass:"errorTips"},[_c('i'),_vm._v(" "),_c('span',[_vm._v("\n                            "+_vm._s(this.tipMsg1)+"\n                        ")])]):_vm._e()]),_vm._v(" "),_c('Form',{ref:"loginDialog",attrs:{"model":_vm.passwordLogin}},[_c('FormItem',{staticClass:"form-item",attrs:{"prop":"username"}},[_c('i',{staticClass:"user-icon"}),_vm._v(" "),_c('Input',{attrs:{"focus":"","maxlength":_vm.maxLength64,"placeholder":"用户名/手机号"},model:{value:(_vm.passwordLogin.username),callback:function ($$v) {_vm.$set(_vm.passwordLogin, "username", $$v)},expression:"passwordLogin.username"}})],1),_vm._v(" "),_c('FormItem',{staticClass:"form-item",attrs:{"prop":"password"}},[_c('i',{staticClass:"password-icon"}),_vm._v(" "),_c('Input',{attrs:{"type":"password","maxlength":_vm.maxLength16,"placeholder":"账户密码"},model:{value:(_vm.passwordLogin.password),callback:function ($$v) {_vm.$set(_vm.passwordLogin, "password", $$v)},expression:"passwordLogin.password"}})],1),_vm._v(" "),(_vm.isShowImgCode)?_c('FormItem',{staticClass:"form-item",attrs:{"prop":"imgCode"}},[_c('i',{staticClass:"img-code-icon"}),_vm._v(" "),_c('Input',{staticClass:"img-code-input",attrs:{"maxlength":_vm.maxLength6,"placeholder":"请输入右侧验证码"},model:{value:(_vm.passwordLogin.imgCode),callback:function ($$v) {_vm.$set(_vm.passwordLogin, "imgCode", $$v)},expression:"passwordLogin.imgCode"}}),_vm._v(" "),_c('img',{staticClass:"img-code",attrs:{"src":_vm.imgCodeUrl,"alt":""},on:{"click":_vm.refreshImgCode}})],1):_vm._e(),_vm._v(" "),_c('Checkbox',{staticClass:"remember-count",model:{value:(_vm.rememberCount),callback:function ($$v) {_vm.rememberCount=$$v},expression:"rememberCount"}},[_vm._v("记住账号")])],1),_vm._v(" "),_c('Button',{staticClass:"submit-password-login",attrs:{"type":"primary"},on:{"click":_vm.loginByUserCount}},[(!_vm.loginByUserCountLoading)?_c('span',[_vm._v("登 录")]):_c('span',[_vm._v("Loading...")])])],1):_vm._e(),_vm._v(" "),(!_vm.isShowTab1)?_c('div',{staticClass:"password-login-box"},[_c('div',{staticClass:"msgTips"},[(!_vm.isTab2Success  && _vm.isShowTip2)?_c('div',{staticClass:"errorTips"},[_c('i'),_vm._v(" "),_c('span',[_vm._v("\n                            "+_vm._s(this.tipMsg2)+"\n                        ")])]):_vm._e(),_vm._v(" "),(_vm.isTab2Success && _vm.isShowTip2)?_c('div',{staticClass:"successTips"},[_c('i'),_vm._v(" "),_c('span',[_vm._v("\n                            "+_vm._s(this.tipMsg2)+"\n                        ")])]):_vm._e()]),_vm._v(" "),_c('Form',{ref:"loginDialog",attrs:{"model":_vm.mobileLogin}},[_c('FormItem',{staticClass:"form-item",attrs:{"prop":"mobile"}},[_c('i',{staticClass:"user-icon"}),_vm._v(" "),_c('Input',{attrs:{"maxlength":_vm.maxLength11,"placeholder":"手机号"},model:{value:(_vm.mobileLogin.mobile),callback:function ($$v) {_vm.$set(_vm.mobileLogin, "mobile", $$v)},expression:"mobileLogin.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('FormItem',{staticClass:"mobile-code",attrs:{"prop":"mobileCode"}},[_c('i',{staticClass:"password-icon"}),_vm._v(" "),_c('Input',{attrs:{"maxlength":_vm.maxLength6,"placeholder":"短信验证码"},model:{value:(_vm.mobileLogin.mobileCode),callback:function ($$v) {_vm.$set(_vm.mobileLogin, "mobileCode", $$v)},expression:"mobileLogin.mobileCode"}})],1),_vm._v(" "),_c('Button',{staticClass:"time-count",attrs:{"loading":_vm.loading},on:{"click":_vm.getMobileCode}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.getMobileCodeTxt))]):_c('span',[_vm._v("发送中...")])])],1)],1),_vm._v(" "),_c('Button',{staticClass:"submit-password-login",attrs:{"type":"primary","loading":_vm.loginByMobileLoading},on:{"click":_vm.loginByMobile}},[(!_vm.loginByMobileLoading)?_c('span',[_vm._v("登 录")]):_c('span',[_vm._v("Loading...")])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"login-dialog-bottom"},[_c('div',{staticClass:"other-link"},[_c('a',{attrs:{"href":_vm.register,"target":"_self"}},[_vm._v("立即注册")]),_vm._v(" "),_c('span'),_vm._v(" "),_c('a',{attrs:{"href":_vm.forgotPassword,"target":"_self"}},[_vm._v("忘记密码？")])]),_vm._v(" "),_c('p',{staticClass:"login-dialog-tips"},[_vm._v("\n                正在使用SSL安全登录\n            ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ieZ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-page"},[_c('PageTopBar'),_vm._v(" "),_c('pageHeaderBar'),_vm._v(" "),_c('SideBar'),_vm._v(" "),_c('MenuBar',{attrs:{"pageType":"Index"}}),_vm._v(" "),_c('swiper',{ref:"mySwiper",staticClass:"slider",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.carouselList),function(item,index){return _c('swiper-slide',{key:index},[_c('div',{staticClass:"slider-outer",style:(_vm.returnBgColor(item.backgroundColor))},[_c('div',{staticClass:"slider-item"},[_c('a',{attrs:{"href":item.targetUrl}},[_c('img',{attrs:{"src":item.bannerPicUrl,"alt":""}})])])])])}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2),_vm._v(" "),(_vm.advertisementListLoad)?_c('LoadingBar',{attrs:{"width":"1200px","id":"advertisementList","height":"120px"}}):_vm._e(),_vm._v(" "),(!_vm.advertisementListLoad && _vm.advertisementList.length >= 4)?_c('div',{staticClass:"four-ad"},[_c('ul',_vm._l((_vm.advertisementList),function(item,index){return (index < 4)?_c('li',[_c('a',{attrs:{"href":item.targetUrl}},[_c('img',{attrs:{"src":item.advertisementPicUrl,"alt":""}})])]):_vm._e()}))]):_vm._e(),_vm._v(" "),(_vm.productInfoListLoad)?_c('LoadingBar',{attrs:{"width":"1200px","id":"productInfoListList","height":"120px"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.productInfoList),function(item,index){return (_vm.returnResult(index, item) && !_vm.productInfoListLoad)?_c('div',{staticClass:"floor"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(item.fieldName))])]),_vm._v(" "),_c('div',{staticClass:"floor-content"},[_c('div',{staticClass:"left-content"},[(item.targetUrl && item.targetUrl.length > 0)?_c('a',{attrs:{"href":item.targetUrl}},[(item.fieldPicUrl != null && item.fieldPicUrl.length > 0)?_c('img',{attrs:{"src":item.fieldPicUrl,"alt":""}}):_c('img',{attrs:{"src":_vm.productDefault,"alt":""}})]):_c('a',[(item.fieldPicUrl != null && item.fieldPicUrl.length > 0)?_c('img',{attrs:{"src":item.fieldPicUrl,"alt":""}}):_c('img',{attrs:{"src":_vm.productDefault,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"right-content"},[_c('ul',_vm._l((item.prdList),function(list,i){return (i < 3)?_c('li',[_c('a',{attrs:{"href":list.targetUrl}},[_c('img',{attrs:{"src":_vm.returnImgPath(list.prdPhoto, item.imageRoot),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('span',{staticClass:"p-title"},[_vm._v(_vm._s(list.prdName))]),_vm._v(" "),_c('span',{staticClass:"p-price"},[_vm._v("￥"),_c('b',[_vm._v(_vm._s(_vm.formatCount(list.prdPrice)))])])]),_vm._v(" "),_c('p',[_vm._v("已售"+_vm._s(_vm.returnSoldNum(list.soldCount)))])])]):_vm._e()}))])])]):_vm._e()}),_vm._v(" "),(_vm.getSecAdLoad)?_c('LoadingBar',{attrs:{"width":"1200px","id":"getSecAd","height":"120px"}}):_vm._e(),_vm._v(" "),(!_vm.getSecAdLoad && _vm.secAdList.length > 0)?_c('div',{staticClass:"ad-area"},_vm._l((_vm.secAdList),function(item,index){return (index == 0)?_c('a',{attrs:{"href":item.targetUrl}},[_c('img',{attrs:{"src":item.advertisementPicUrl,"alt":""}})]):_vm._e()})):_vm._e(),_vm._v(" "),(_vm.clinicListLoad)?_c('LoadingBar',{attrs:{"width":"1200px","id":"clinicListLoad","height":"120px"}}):_vm._e(),_vm._v(" "),(!_vm.clinicListLoad && _vm.clinicList.length > 0)?_c('div',{staticClass:"floor floor2"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("优质诊所")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.clinicUrl}},[_vm._v("更多>")])]),_vm._v(" "),_c('div',{staticClass:"floor2-content"},[_c('ul',[_vm._l((_vm.clinicList),function(item,index){return (index == 0)?_c('li',{staticClass:"first"},[_c('a',{staticClass:"img-box",attrs:{"href":_vm.goToDetailClinic(item.clinicId)}},[_c('img',{attrs:{"src":_vm.returnImgPath(item.clinicFacadeName,item.imageRootUrl, 'middle'),"onerror":_vm.defaultClinicImg,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"clinic-info"},[_c('p',{staticClass:"clinic-name"},[_c('a',{attrs:{"href":""}},[_vm._v(_vm._s(item.clinicName))])]),_vm._v(" "),_c('p',{staticClass:"clinic-address"},[_vm._v(_vm._s(item.address))]),_vm._v(" "),_c('a',{staticClass:"view-btn",attrs:{"href":_vm.goToDetailClinic(item.clinicId)}},[_vm._v("查看详情")]),_vm._v(" "),_c('a',{staticClass:"doctor-logo",attrs:{"href":_vm.goToDetailClinic(item.clinicId)}},[(item.doctorPhotoPath)?_c('img',{attrs:{"src":_vm.returnDoctorLog(item.doctorPhotoPath),"onerror":_vm.staticRoot + '/img/userlogo.png',"alt":""}}):_c('img',{attrs:{"src":_vm.staticRoot + '/img/userlogo.png',"onerror":_vm.staticRoot + '/img/userlogo.png',"alt":""}})]),_vm._v(" "),(item.doctorName)?_c('p',{staticClass:"doctor"},[_vm._v("优质医生:"+_vm._s(item.doctorName))]):_c('p',{staticClass:"doctor"},[_vm._v("优质医生")])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.clinicList),function(item,index){return (index > 0 && index < 8)?_c('li',[_c('a',{attrs:{"href":_vm.goToDetailClinic(item.clinicId)}},[_c('div',{staticClass:"img-box2"},[_c('img',{attrs:{"src":_vm.returnImgPath(item.clinicFacadeName, item.imageRootUrl, 'middle'),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"clinic-info2"},[_c('div',{staticClass:"clinic-name2"},[_vm._v(_vm._s(item.clinicName))])]),_vm._v(" "),_c('div',{staticClass:"clinic-desc"},[_vm._v("\n                            "+_vm._s(item.address)+"\n                        ")])])]):_vm._e()})],2)])]):_vm._e(),_vm._v(" "),(_vm.getThirdAdLoad)?_c('LoadingBar',{attrs:{"width":"1200px","id":"getThirdAd","height":"120px"}}):_vm._e(),_vm._v(" "),(!_vm.getThirdAdLoad && _vm.thirdAdList.length > 0)?_c('div',{staticClass:"ad-area"},_vm._l((_vm.thirdAdList),function(item,index){return (index == 0)?_c('a',{attrs:{"href":item.targetUrl}},[_c('img',{attrs:{"src":item.advertisementPicUrl,"alt":""}})]):_vm._e()})):_vm._e(),_vm._v(" "),(_vm.informationListLoad)?_c('LoadingBar',{attrs:{"width":"1200px","id":"informationListLoad","height":"120px"}}):_vm._e(),_vm._v(" "),(!_vm.informationListLoad && _vm.informationList.length > 0)?_c('div',{staticClass:"floor floor2 floor3"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("健康资讯")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.healthMore}},[_vm._v("更多>")])]),_vm._v(" "),_c('div',{staticClass:"floor2-content"},[_c('ul',[_vm._l((_vm.informationList),function(item,index){return (index == 0)?_c('li',{staticClass:"first"},[_c('a',{staticClass:"img-box",attrs:{"href":_vm.returnDetailHeathDetail(item.infoId)}},[_c('img',{attrs:{"src":item.picUrl,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"article"},[_c('a',{attrs:{"href":_vm.returnDetailHeathDetail(item.infoId)}},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"paragraph"},[_vm._v("\n                            "+_vm._s(item.content)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"bottom-info"},[_c('div',{staticClass:"star"},[_c('i'),_vm._v(_vm._s(item.collectionQuantity)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"eye"},[_c('i'),_vm._v(_vm._s(item.readingQuantity)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v("\n                                "+_vm._s(item.releaseDate)+"\n                            ")])])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.informationList),function(item,index){return (index > 0 && index < 3)?_c('li',[_c('a',{attrs:{"href":_vm.returnDetailHeathDetail(item.infoId)}},[_c('div',{staticClass:"img-box2"},[_c('img',{attrs:{"src":item.picUrl,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"zix-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"bottom-info"},[_c('div',{staticClass:"star"},[_c('i'),_vm._v(_vm._s(item.collectionQuantity)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"eye"},[_c('i'),_vm._v(_vm._s(item.readingQuantity)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v("\n                                "+_vm._s(item.releaseDate)+"\n                            ")])])])]):_vm._e()})],2)])]):_vm._e(),_vm._v(" "),_c('MsgDialog'),_vm._v(" "),_c('FooterBar')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jRlB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jlGn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jm0R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"footer-b"},[_c('div',{staticClass:"left"},_vm._l((_vm.hotLink),function(item){return _c('dl',[_c('dt',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('dd',_vm._l((item.children),function(list){return (list.href.length > 0)?_c('a',{attrs:{"target":list.blank ? '_blank' : '_self',"href":list.href}},[_vm._v(_vm._s(list.title))]):_vm._e()}))])})),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"footer-c"},[_c('div',{staticClass:"footer-c-a"},[_c('span',[_vm._v("合作伙伴")]),_vm._v(" "),_vm._l((_vm.partner),function(item){return _c('a',{attrs:{"href":"javascript:;","title":item.title},on:{"click":function($event){_vm.goOutPage(item.href)}}},[_c('img',{class:item.className,attrs:{"src":item.imgUrl}})])})],2),_vm._v(" "),_c('div',{staticClass:"friend-link",attrs:{"id":"friend-link"}},[_c('div',{staticClass:"friend-link-txt"},_vm._l((_vm.bottomLink),function(item){return _c('a',{attrs:{"href":_vm.returnHref(item.linkId)}},[_vm._v(_vm._s(item.linkTitle))])})),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-a"},[_c('div',{staticClass:"footer-floor-1"},[_c('dl',{staticClass:"ylfw"},[_c('dt',[_c('i')]),_vm._v(" "),_c('dd',[_c('a',{staticClass:"title"},[_vm._v("医疗服务")]),_vm._v(" "),_c('a',[_vm._v("一键查找对应服务")]),_vm._v(" "),_c('a',[_vm._v("告别就医烦恼")])])]),_vm._v(" "),_c('dl',{staticClass:"qytg"},[_c('dt',[_c('i')]),_vm._v(" "),_c('dd',[_c('a',{staticClass:"title"},[_vm._v("区域推广")]),_vm._v(" "),_c('a',[_vm._v("精准推送有效信息")]),_vm._v(" "),_c('a',[_vm._v("个性化满足需求")])])]),_vm._v(" "),_c('dl',{staticClass:"qwtg"},[_c('dt',[_c('i')]),_vm._v(" "),_c('dd',[_c('a',{staticClass:"title"},[_vm._v("权威科普")]),_vm._v(" "),_c('a',[_vm._v("汇聚权威科普资讯")]),_vm._v(" "),_c('a',[_vm._v("最贴心健康顾问")])])]),_vm._v(" "),_c('dl',{staticClass:"ylfz"},[_c('dt',[_c('i')]),_vm._v(" "),_c('dd',[_c('a',{staticClass:"title"},[_vm._v("医疗辅助")]),_vm._v(" "),_c('a',[_vm._v("匹配丰富产品工具")]),_vm._v(" "),_c('a',[_vm._v("享受服务更便捷")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('p',[_vm._v("万家为全国66个城市提供医疗相关服务 ")]),_vm._v(" "),_c('div',{staticClass:"hot-line"},[_c('dl',[_c('dt',[_c('i')]),_vm._v(" "),_c('dd',[_c('a',[_vm._v("全国服务热线")]),_vm._v(" "),_c('a',{staticClass:"hot-number"},[_vm._v("400-931-6788")]),_vm._v(" "),_c('a',{staticClass:"hot-txt"},[_vm._v("全年无休9:00-20:00")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("　\n                "),_c('a',{staticStyle:{"color":"#f70"},attrs:{"target":"_blank","href":"https://beian.miit.gov.cn"}},[_vm._v("粤ICP备16081915号")]),_vm._v("　\n                互联网药品信息服务资格证书　"),_c('a',{staticStyle:{"color":"#f70"},attrs:{"target":"_blank","href":"https://mall.pinganwj.com/resources/static/img/wjmall_cert.png"}},[_vm._v("(粤)-经营性-2018-0080")]),_vm._v(" "),_c('a',{staticStyle:{"display":"inline-block","text-decoration":"none","height":"20px","line-height":"20px","margin-left":"10px"},attrs:{"target":"_blank","href":"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502002443"}},[_c('img',{staticStyle:{"float":"left"},attrs:{"src":__webpack_require__("zse5")}}),_c('span',{staticStyle:{"margin":"0px 0px 0px 5px","color":"#939393"}},[_vm._v("粤公网安备 44030502002443号")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k0Uf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_utils_kf_dialog_js__ = __webpack_require__("2ikA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_url__ = __webpack_require__("FKvS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            feedBack: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].commonRoot + "/sso/feedback?feedbackSource=6",
            ewm: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].static + "/img/wx-ewm.jpg"
        };
    },

    created: function created() {},
    mounted: function mounted() {},
    methods: {
        open_kf_dialog: function open_kf_dialog() {
            __WEBPACK_IMPORTED_MODULE_0__static_js_utils_kf_dialog_js__["a" /* default */].webTalkOnline(1000, 618);
        },
        scrollTop: function scrollTop() {
            $("html, body").stop().animate({ scrollTop: 0 }, 400);
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "kME/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_simpleHeaderBar__ = __webpack_require__("rpep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_simpleFooterBar__ = __webpack_require__("+Wgm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        simpleHeaderBar: __WEBPACK_IMPORTED_MODULE_1__Common_simpleHeaderBar__["a" /* default */],
        simpleFooterBar: __WEBPACK_IMPORTED_MODULE_2__Common_simpleFooterBar__["a" /* default */]
    },

    data: function data() {
        return {
            feedPlaceHolder: "请尽可能详细描述您的需求／问题，建议按下面模版填写\n遇到的问题：\n希望的效果：\n其他的要求：",
            isShowTips: true,
            leftWordsCount: 500,
            maxLength20: 20,
            maxLength12: 12,
            maxLength50: 50,
            maxLength500: 500,
            loading: false,
            isUploadBtnShow: true,
            imgUpload: __WEBPACK_IMPORTED_MODULE_3__config_url__["a" /* default */].saveFeedbackPicture,
            autoFocus: false,
            visible: false,
            imgList: [],
            formValidate: {
                title: '',
                feedbackContent: '',
                hospitalTitle: "",
                feedbackType: '',
                uploadList: [],
                contactName: "",
                contactPhone: ""
            },
            ruleValidate: {
                feedbackType: [{ required: true, message: '请选择反馈类型！', trigger: 'change' }],
                title: [{ required: true, message: '反馈主题不能为空！', trigger: 'blur' }],
                contactName: [{ required: true, message: '联系人姓名不能为空！', trigger: 'blur' }, { type: 'string', trigger: 'blur' }],
                contactPhone: [{ required: true, message: '联系电话不能为空！', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        var errors = [];
                        if (!(value.match(/^(13|15|17|18|14)[0-9]{9}$/) || value.match(/^0\d{2,3}-\d{7,8}$/))) {
                            callback('联系电话格式不正确');
                        }
                        callback(errors);
                    },
                    trigger: 'blur'
                }],
                feedbackContent: [{ required: true, message: '反馈内容不能为空！', trigger: 'blur' }]
            }
        };
    },

    created: function created() {
        this.getUserMobile();
    },
    mounted: function mounted() {
        this.formValidate.uploadList = this.$refs.upload.fileList;
    },
    methods: {
        watchWords: function watchWords() {
            var len = this.formValidate.feedbackContent.length;
            this.leftWordsCount = 500 - len;
        },
        getUserMobile: function getUserMobile() {
            var _this = this;
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__config_url__["a" /* default */].getUserMobile).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS" && res.result != null) {
                    _this.formValidate.contactPhone = res.result;
                }
            }).catch(function () {
                _this.$Message.error('数据获取失败,请稍后再试!');
            });
        },
        handleReset: function handleReset() {
            window.location.href = window.location.href;
        },
        handleSubmit: function handleSubmit(name) {
            var _this = this;
            _this.$refs[name].validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    var feedbackSource = _this.$route.query.feedbackSource;
                    var params = {
                        userId: __WEBPACK_IMPORTED_MODULE_3__config_url__["a" /* default */].userId
                    };
                    var clinicFeedBackImages = [];
                    _this.formValidate.uploadList.forEach(function (item, index) {
                        clinicFeedBackImages.push({
                            "imageId": item.response.result.imageId,
                            "imageTypeCode": "OPERATION_FEEDBACK",
                            "imageOrder": index + 1,
                            "imageSource": feedbackSource
                        });
                    });
                    var feedbackInfo = {
                        clinicFeedBack: {
                            "feedbackTheme": _this.formValidate.title.trim(),
                            "feedbackType": _this.formValidate.feedbackType,
                            "contactName": _this.formValidate.contactName.trim(),
                            "contactPhone": _this.formValidate.contactPhone.trim(),
                            "feedbackContent": _this.formValidate.feedbackContent.trim(),
                            "feedbackSource": feedbackSource,
                            "userClinicName": _this.formValidate.hospitalTitle.trim()
                        },
                        clinicFeedBackImages: clinicFeedBackImages
                    };
                    params.feedbackInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(feedbackInfo);
                    __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                        url: __WEBPACK_IMPORTED_MODULE_3__config_url__["a" /* default */].saveFeedbackInfo,
                        method: "post",
                        data: params,
                        transformRequest: [function (data) {
                            var ret = [];
                            for (var it in data) {
                                ret.push(encodeURIComponent(it) + '=' + encodeURIComponent(data[it]));
                            }
                            return ret.join("&");
                        }]
                    }).then(function (response) {
                        var res = response.data;
                        _this.loading = false;
                        if (res.status == "SUCCESS") {
                            _this.visible = true;
                        } else {
                            _this.$Message.error(res.errorMsg);
                        }
                    }).catch(function () {
                        _this.loading = true;
                        _this.$Message.error('数据提交失败，请稍后再试！');
                    });
                }
            });
        },
        handleRemove: function handleRemove(file) {
            var fileList = this.$refs.upload.fileList;
            this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
            if (this.formValidate.uploadList.length < 5) {
                this.isUploadBtnShow = true;
            } else {
                this.isUploadBtnShow = false;
            }
        },
        handleSuccess: function handleSuccess(res, file) {
            if (file.response.status == "SUCCESS") {
                file.url = file.response.result.imageUrl;
                file.name = file.response.result.imageId;
                if (this.formValidate.uploadList.length < 5) {
                    this.isUploadBtnShow = true;
                } else {
                    this.isUploadBtnShow = false;
                }
            } else {
                this.$Message.error('图片上传失败，请稍后再试');
            }
        },
        handleError: function handleError() {
            if (this.formValidate.uploadList.length < 5) {
                this.isUploadBtnShow = true;
            } else {
                this.isUploadBtnShow = false;
            }
            this.$Message.error('图片上传失败，请稍后再试');
        },
        handleFormatError: function handleFormatError(file) {
            this.$Message.error('请上传jpg,jpeg,png格式图片');
        },
        handleMaxSize: function handleMaxSize(file) {
            this.$Message.error('图片必须小于2M');
        },
        handleBeforeUpload: function handleBeforeUpload() {
            var check = this.formValidate.uploadList.length < 5;
            if (!check) {
                this.$Message.error('最多只能上传5张图片');
            }
            if (this.formValidate.uploadList.length < 4) {
                this.isUploadBtnShow = true;
            } else {
                this.isUploadBtnShow = false;
            }
            return check;
        }
    }
});

/***/ }),

/***/ "kjeq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    isShowLoginDialog: false,
    cartNum: 0, //购物车数量
    userInfo: {},
    userId: 0,
    defaultCity: "上海",
    keyWord: "",
    isCartPopTipShow: false // 加入购物车弹层提示
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "m/mO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('simpleHeaderBar',{attrs:{"name":"问题反馈"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticStyle:{"margin":"100px"}},[_c('LoadingBar',{attrs:{"height":"120px"}})],1):_c('div',[_c('div',{staticClass:"survey"},[_c('div',{staticClass:"survey-reply-header"},[_vm._v("\n                我的问题 — 查看详情\n            ")]),_vm._v(" "),(_vm.result.FeedBack != null)?_c('div',{staticClass:"survey-input"},[_c('div',{staticClass:"reply-box"},[_c('ul',[_c('li',[_c('label',[_vm._v("\n                                反馈主题：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info"},[_vm._v("\n                                "+_vm._s(_vm.result.FeedBack.feedbackTheme)+"\n                            ")])]),_vm._v(" "),_c('li',[_c('label',[_vm._v("\n                                反馈内容：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info",domProps:{"innerHTML":_vm._s(_vm.result.FeedBack.feedbackContent.replace(/＼n/g,'<br/>').replace(/\n/g,'<br/>'))}})]),_vm._v(" "),(_vm.result.FeedBack.userClinicName != null)?_c('li',[_c('label',[_vm._v("\n                                医疗机构：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info"},[_vm._v("\n                                "+_vm._s(_vm.result.FeedBack.userClinicName)+"\n                            ")])]):_vm._e(),_vm._v(" "),(_vm.result.FeedBackImages != null && _vm.result.FeedBackImages.length > 0)?_c('li',[_c('label',[_vm._v("\n                                图片：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info"},[_c('div',{staticClass:"img-list"},_vm._l((_vm.result.FeedBackImages),function(item){return _c('img',{attrs:{"src":item.imageServerPath + item.imageRelativePath,"alt":""}})}))])]):_vm._e(),_vm._v(" "),_c('li',[_c('label',[_vm._v("\n                                联系人：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info"},[_vm._v(_vm._s(_vm.result.FeedBack.contactName))])]),_vm._v(" "),_c('li',[_c('label',[_vm._v("\n                                联系电话：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info"},[_vm._v("\n                                "+_vm._s(_vm.result.FeedBack.contactPhone)+"\n                            ")])]),_vm._v(" "),(_vm.result.FeedBack.feedbackResult)?_c('li',[_c('label',[_vm._v("\n                                回复内容：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info"},[_vm._v("\n                                "+_vm._s(_vm.result.FeedBack.feedbackResult)+"\n                            ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"reply-box reply-box-a"},[_c('ul',[_c('li',[_c('label',[_vm._v("\n                                是否解决：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info"},[(_vm.result.FeedBack.evaluateStatus == 0 || _vm.result.FeedBack.evaluateStatus == null)?_c('RadioGroup',{model:{value:(_vm.reply.solveState),callback:function ($$v) {_vm.$set(_vm.reply, "solveState", $$v)},expression:"reply.solveState"}},[_c('Radio',{staticClass:"radio",attrs:{"label":"1"}},[_vm._v("已解决")]),_vm._v(" "),_c('Radio',{staticClass:"radio",attrs:{"label":"0"}},[_vm._v("未解决")])],1):_c('RadioGroup',{staticClass:"radio-disabled",model:{value:(_vm.result.FeedBack.solveState),callback:function ($$v) {_vm.$set(_vm.result.FeedBack, "solveState", $$v)},expression:"result.FeedBack.solveState"}},[_c('Radio',{staticClass:"radio",attrs:{"label":"1","disabled":""}},[_vm._v("已解决")]),_vm._v(" "),_c('Radio',{staticClass:"radio",attrs:{"label":"0","disabled":""}},[_vm._v("未解决")])],1)],1)]),_vm._v(" "),_c('li',[_c('label',[_vm._v("\n                                满意度评价：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info"},[_c('div',{staticClass:"star"},[(_vm.result.FeedBack.evaluateStatus == 0 || _vm.result.FeedBack.evaluateStatus == null)?_c('Rate',{model:{value:(_vm.reply.evaluateStars),callback:function ($$v) {_vm.$set(_vm.reply, "evaluateStars", $$v)},expression:"reply.evaluateStars"}}):_c('Rate',{attrs:{"disabled":""},model:{value:(_vm.result.FeedBack.evaluateStars),callback:function ($$v) {_vm.$set(_vm.result.FeedBack, "evaluateStars", $$v)},expression:"result.FeedBack.evaluateStars"}})],1)])]),_vm._v(" "),(_vm.result.FeedBack.evaluateStatus == 0 || _vm.result.FeedBack.evaluateStatus == null)?_c('li',[_c('label',[_vm._v("\n                                评价内容：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info"},[_c('Input',{staticClass:"textarea",attrs:{"type":"textarea","autosize":{minRows: 5,maxRows: 10},"placeholder":"请输入评价内容(200字以内)","maxlength":_vm.maxLength200},model:{value:(_vm.reply.evaluateContent),callback:function ($$v) {_vm.$set(_vm.reply, "evaluateContent", $$v)},expression:"reply.evaluateContent"}})],1)]):(_vm.result.FeedBack.evaluateStatus == 1 && _vm.result.FeedBack.evaluateContent != null && _vm.result.FeedBack.evaluateContent.length > 0)?_c('li',[_c('label',[_vm._v("\n                                评价内容：\n                            ")]),_vm._v(" "),_c('div',{staticClass:"reply-info"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.result.FeedBack.evaluateContent.replace(/＼n/g,'<br/>').replace(/\n/g,'<br/>'))}})])]):_vm._e()])]),_vm._v(" "),(_vm.result.FeedBack.evaluateStatus == 0 || _vm.result.FeedBack.evaluateStatus == null)?_c('div',{staticClass:"btn"},[_c('Button',{staticClass:"btn-submit",attrs:{"type":"primary","loading":_vm.submitLoading},on:{"click":function($event){_vm.handleSubmit()}}},[(!_vm.submitLoading)?_c('span',[_vm._v("提交")]):_c('span',[_vm._v("Loading...")])])],1):_vm._e()]):_c('div',{staticClass:"survey-input"},[_vm._m(0)])])]),_vm._v(" "),_c('simpleFooterBar')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-result"},[_c('p',{staticStyle:{"text-align":"center","font-size":"14px","margin":"100px"}},[_vm._v("暂无数据")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mT9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("VpaC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2b1c0fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("KKUe");
function injectStyle (ssrContext) {
  __webpack_require__("8B1J")
  __webpack_require__("dFcR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f2b1c0fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2b1c0fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mTeZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_common__ = __webpack_require__("/sA3");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var Base64 = __webpack_require__("xrTZ").Base64;
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        isRefreshTop: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            loginByUserCountLoading: false,
            loginByMobileLoading: false,
            register: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].register,
            forgotPassword: __WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].forgotPassword,
            smsId: "",
            isShowTip1: false,
            isShowTip2: false,
            isTab1Success: true,
            sessionKey: new Date().getTime() + parseInt(Math.random() * 1000000),
            tipMsg1: "",
            isTab2Success: true,
            tipMsg2: "",
            loading: false,
            imgCodeUrl: "",
            getMobileCodeTxt: "点击获取",
            isCanGetMobileCode: true, //是否能点击获取验证码
            hasClickGetMobileCode: false, //是否点击过获取验证码
            title: [{
                name: "密码登录",
                isSelected: true
            }, {
                name: "手机短信登录",
                isSelected: false
            }],
            isShowTab1: true,
            isShow: true,
            maxLength64: 64,
            maxLength16: 16,
            maxLength6: 6,
            maxLength11: 11,
            isShowImgCode: false,
            rememberCount: false,
            passwordLogin: {
                username: "",
                password: "",
                imgCode: ""
            },
            mobileLogin: {
                mobile: "",
                mobileCode: ""
            },
            passwordLoginValidate1: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            passwordLoginValidate2: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                imgCode: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }]
            },
            mobileLoginValidate: {
                mobile: [{ required: true, message: '请输入手机号码', trigger: 'blur' }, {
                    validator: function validator(rule, value, callback) {
                        var errors = [];
                        if (!value.match(/^(13|15|17|18|14)[0-9]{9}$/)) {
                            callback('手机号码格式不正确');
                        }
                        callback(errors);
                    },
                    trigger: 'blur'
                }],
                mobileCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
            }
        };
    },

    created: function created() {
        this.getPicCheckFlag();
        if (__WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].getCookie("wanjia_passport_user_name")) {
            this.passwordLogin.username = Base64.decode(__WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].getCookie("wanjia_passport_user_name").replace("%3D%3D", ""));
        }
    },
    mounted: function mounted() {},
    computed: {
        isShowLoginDialog: function isShowLoginDialog() {
            return this.$store.state.isShowLoginDialog;
        }
    },
    methods: {
        //判断是否显示验证码
        getPicCheckFlag: function getPicCheckFlag() {
            var _this = this;
            _this.$http.jsonp(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].getPicCheckFlag, {
                'jsonp': 'jsonpCallback'
            }).then(function (res) {
                var r = res.body;
                /*r.result = "yes";*/
                if (r.result == "yes") {
                    _this.isShowImgCode = true;
                    _this.refreshImgCode();
                } else {
                    _this.isShowImgCode = false;
                }
            }).catch(function () {});
        },

        //检查用户名格式
        userCountValidateCheck: function userCountValidateCheck() {
            var _this = this;
            if (_this.passwordLogin.username.trim().length <= 0) {
                _this.isShowTip1 = true;
                _this.isTab1Success = false;
                _this.tipMsg1 = "用户名不能为空！";
                return false;
            } else {
                return true;
            }
        },

        //检查密码格式
        passwordValidateCheck: function passwordValidateCheck() {
            var _this = this;
            if (_this.passwordLogin.password.trim().length <= 0) {
                _this.isShowTip1 = true;
                _this.isTab1Success = false;
                _this.tipMsg1 = "密码不能为空！";
                return false;
            } else {
                return true;
            }
        },

        //检查图形验证码
        imgCodeValidateCheck: function imgCodeValidateCheck() {
            var _this = this;
            if (_this.isShowImgCode) {
                if (_this.passwordLogin.imgCode.trim().length <= 0) {
                    _this.isShowTip1 = true;
                    _this.isTab1Success = false;
                    _this.tipMsg1 = "图形验证码不能为空！";
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },

        //检查手机验证码格式
        mobileCodeValidateCheck: function mobileCodeValidateCheck() {
            var _this = this;
            if (_this.mobileLogin.mobileCode.trim().length <= 0) {
                _this.isShowTip2 = true;
                _this.isTab2Success = false;
                _this.tipMsg2 = "手机验证码不能为空";
                return false;
            } else if (_this.mobileLogin.mobileCode.trim().length != 6) {
                _this.isShowTip2 = true;
                _this.isTab2Success = false;
                _this.tipMsg2 = "手机验证码格式不正确";
                return false;
            } else {
                return true;
            }
        },

        //检查手机格式
        mobileValidateCheck: function mobileValidateCheck() {
            var _this = this;
            if (_this.mobileLogin.mobile.trim().length <= 0) {
                _this.isShowTip2 = true;
                _this.isTab2Success = false;
                _this.tipMsg2 = "手机号码不能为空";
                return false;
            } else if (!_this.mobileLogin.mobile.trim().match(/^(13|15|17|18|14)[0-9]{9}$/)) {
                _this.isShowTip2 = true;
                _this.isTab2Success = false;
                _this.tipMsg2 = "手机号码格式不正确";
                return false;
            } else {
                return true;
            }
        },

        //短信验证码方式登录
        loginByMobile: function loginByMobile() {
            var _this = this;
            if (!_this.mobileValidateCheck()) {
                return;
            }
            if (!_this.hasClickGetMobileCode) {
                _this.isShowTip2 = true;
                _this.isTab2Success = false;
                _this.tipMsg2 = "请获取短信验证码！";
                return;
            }
            if (!_this.mobileCodeValidateCheck()) {
                return;
            }
            _this.loginByMobileLoading = true;
            var params = {
                sessionId: "dsads#ae3sdasdwqw",
                mobileNum: _this.mobileLogin.mobile.trim(),
                smsCode: _this.mobileLogin.mobileCode.trim(),
                smsId: _this.smsId
            };
            _this.$http.jsonp(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].loginByMobile, {
                params: params,
                jsonp: 'jsonpCallback'
            }).then(function (res) {
                _this.loginByMobileLoading = false;
                var res = res.body;
                if (res.status == "ERROR") {
                    _this.isShowTip2 = true;
                    _this.isTab2Success = false;
                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.errorMsg) != undefined) {
                        if (res.errorCode == "smsCodeError") {
                            _this.tipMsg2 = '动态码错误，您还能输入' + res.result + '次';
                        } else {
                            if (res.errorMsg == "") {
                                _this.tipMsg2 = "系统繁忙,登录失败!";
                            } else {
                                _this.tipMsg2 = res.errorMsg;
                            }
                        }
                    } else {
                        _this.tipMsg2 = "系统繁忙,登录失败!";
                    }
                } else {
                    var params = {
                        x: _this.sessionKey,
                        userName: _this.mobileLogin.mobile.trim(),
                        userPwd: _this.mobileLogin.mobileCode.trim()
                    };
                    _this.loginSSO(params);
                    _this.isShowTip2 = false;
                    _this.$store.commit('changeShowLoginDialogState');
                }
            }).catch(function () {
                _this.loading = false;
                _this.loginByMobileLoading = false;
                _this.$store.commit('changeShowLoginDialogState');
                console.log('数据获取失败,请稍后再试!');
            });
        },

        //获取图形验证码
        refreshImgCode: function refreshImgCode() {
            var _this = this;
            if (_this.isShowImgCode) {
                _this.sessionKey = new Date().getTime() + parseInt(Math.random() * 1000000);
                _this.imgCodeUrl = window.nginxRoot + "/verification/code/num/web/6/" + _this.sessionKey + "/180";
            }
        },
        loginByUserCount: function loginByUserCount() {
            var _this = this;
            if (!_this.userCountValidateCheck()) {
                return;
            }
            if (!_this.passwordValidateCheck()) {
                return;
            }
            if (!_this.imgCodeValidateCheck()) {
                return;
            }
            _this.loginByUserCountLoading = true;

            if (_this.isShowImgCode) {
                var params = {
                    sessionKey: _this.sessionKey,
                    randomCode: _this.passwordLogin.imgCode.trim(),
                    userId: _this.passwordLogin.username.trim(),
                    userPwd: _this.passwordLogin.password.trim()
                };
            } else {
                var params = {
                    sessionKey: _this.sessionKey,
                    userId: _this.passwordLogin.username.trim(),
                    userPwd: _this.passwordLogin.password.trim()
                };
            }
            //勾选了记住账号密码，就存放在cookie中
            if (_this.rememberCount) {
                var _count = Base64.encode(_this.passwordLogin.username.trim()).replace("==", "");
                __WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].setCookie("wanjia_passport_user_name", _count, 12 * 30);
            }
            _this.$http.jsonp(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].loginByWeb, {
                params: params,
                'jsonp': 'jsonpCallback'
            }).then(function (res) {
                _this.loginByUserCountLoading = false;
                var result = res.body;
                if (result.status == "SUCCESS") {
                    if (_this.isShowImgCode) {
                        var ssoParams = {
                            userName: _this.passwordLogin.username,
                            userPwd: _this.passwordLogin.password,
                            x: _this.sessionKey,
                            sessionKey: _this.sessionKey,
                            randomCode: _this.passwordLogin.imgCode
                        };
                    } else {
                        var ssoParams = {
                            userName: _this.passwordLogin.username,
                            userPwd: _this.passwordLogin.password,
                            x: _this.sessionKey,
                            sessionKey: _this.sessionKey
                        };
                    }
                    _this.loginSSO(ssoParams);
                    _this.isShowTip1 = false;
                    _this.$store.commit('changeShowLoginDialogState');
                } else {
                    if (result.errorCode == "needActiveByMail") {
                        // 用户需要通过邮箱激活，跳转激活页面
                        window.location.href = casRoot + "/email?q=" + result.result;
                        return;
                    }
                    _this.isShowTip1 = true;
                    _this.isTab1Success = false;
                    _this.getPicCheckFlag();
                    if (result.errorCode == "timeOut") {
                        _this.tipMsg1 = "页面信息已失效,请重新刷新页面";
                    } else if (result.errorCode == "userUnExist") {
                        _this.tipMsg1 = "该用户名尚未注册";
                    } else if (result.errorCode == "userInactive") {
                        _this.tipMsg1 = "该用户尚未激活";
                    } else if (result.errorCode == "userDisable") {
                        _this.tipMsg1 = "该账号已停用";
                    } else if (result.errorCode == "accountLocked") {
                        _this.tipMsg1 = "账户已锁定，请2小时后重试";
                    } else if (result.errorCode == 'authError') {
                        if (result.result && result.result != null && result.result != '') {
                            _this.tipMsg1 = "用户名或密码错误,您还能尝试" + result.result + "次";
                        } else {
                            _this.tipMsg1 = "用户名或密码错误";
                        }
                    } else if (result.errorCode == "accountLockedForever") {
                        _this.tipMsg1 = "账户被永久锁定，请与客服人员联系";
                    } else if (result.errorCode == "pwdUnExist") {
                        _this.tipMsg1 = "该用户名暂未设置密码，请使用动态码登录";
                    } else if (result.errorCode == "userExperied") {
                        _this.tipMsg1 = "账户已失效";
                    } else if (result.errorCode == "pwderror") {
                        _this.tipMsg1 = "密码错误，您还能输入" + result.result + "次";
                    } else if (result.errorCode == "pwdExperied" || result.errorCode == "initFromDB" || result.errorCode == "initFromAdmin" || result.errorCode == "pwdTooSimple") {
                        _this.tipMsg1 = "您的登录密码已过期，为了您的账户安全，请重新设置您的登录密码。";
                    } else {
                        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(result.errorMsg) != undefined && result.errorMsg != null) {
                            _this.tipMsg1 = result.errorMsg;
                        } else {
                            _this.tipMsg1 = "系统繁忙，请稍后再试！";
                        }
                    }
                }
            }).catch(function () {
                _this.loading = false;
                _this.loginByMobileLoading = false;
                console.log('数据获取失败,请稍后再试');
            });
        },


        //登录成功后调用sso
        loginSSO: function loginSSO(params) {
            var _this = this;
            _this.$http.jsonp(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].loginSSO, {
                params: params,
                'jsonp': 'jsonpCallback'
            }).then(function () {
                if (__WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].isIE()) {
                    window.location.reload();
                } else {
                    _this.$store.dispatch("getCartNum");
                    _this.$store.dispatch("getUserInfo", _this.loginSuccessCallBack());
                }
            }).catch(function () {
                if (__WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].isIE()) {
                    window.location.reload();
                } else {
                    _this.$store.dispatch("getCartNum");
                    _this.$store.dispatch("getUserInfo", _this.loginSuccessCallBack());
                }
            });
        },
        loginSuccessCallBack: function loginSuccessCallBack() {
            var count = 0;
            var _this = this;
            var timer = setInterval(function () {
                var userInfo = _this.$store.state.userInfo;
                count++;
                if (count > 2000) {
                    clearInterval(timer);
                } else {
                    if (userInfo != null && userInfo.userId > 0) {
                        if (__WEBPACK_IMPORTED_MODULE_2__static_js_common__["a" /* default */].isIE()) {
                            window.location.reload();
                        } else {
                            _this.$emit('on-success');
                            clearInterval(timer);
                        }
                    }
                }
            }, 10);
        },

        //获取短信验证码
        getMobileCode: function getMobileCode() {
            var _this = this;
            if (!_this.mobileValidateCheck()) {
                return;
            }
            if (!_this.isCanGetMobileCode) {
                return;
            }
            _this.isShowTip2 = false;
            _this.loading = true;
            var params = {
                mobileNum: _this.mobileLogin.mobile.trim(),
                sessionId: "dsads"
            };
            setTimeout(function () {
                _this.$http.jsonp(__WEBPACK_IMPORTED_MODULE_1__config_url__["a" /* default */].sendSmsCode, {
                    params: params,
                    jsonp: 'jsonpCallback'
                }).then(function (res) {
                    _this.loading = false;
                    _this.hasClickGetMobileCode = true; //已经获取过短信验证码
                    var res = res.body;
                    if (res.status == "ERROR") {
                        _this.isShowTip2 = true;
                        _this.isTab2Success = false;
                        if (res.errorCode == "timeOut") {
                            _this.tipMsg2 = "页面信息已失效,请重新刷新页面！";
                        } else if (res.errorCode == "userUnExist") {
                            _this.tipMsg2 = "该手机号码尚未注册!";
                        } else if (res.errorCode == "accountLockedForever") {
                            _this.tipMsg2 = "账户被永久锁定，请与客服人员联系！";
                        } else if (res.errorCode == "accountLocked") {
                            _this.tipMsg2 = "账户已锁定，请2小时后重试！";
                        } else if (res.errorCode == "daySendTooMuch") {
                            _this.tipMsg2 = "今日已到最大发送次数,请明日再试！";
                        } else if (res.errorCode == "hourSendTooMuch") {
                            _this.tipMsg2 = "动态码发送频繁,请稍后再试！";
                        } else {
                            _this.tipMsg2 = "验证码发送失败";
                        }
                    } else {
                        _this.smsId = res.result;
                        _this.isShowTip2 = true;
                        _this.isTab2Success = true;
                        _this.tipMsg2 = "验证码已发送到您手机，2分钟内输入有效!";
                        var seconds = 120;
                        _this.isCanGetMobileCode = false;
                        _this.hasClickGetMobileCode = true;
                        _this.getMobileCodeTxt = seconds + "s";
                        var timer = setInterval(function () {
                            if (seconds > 1) {
                                seconds--;
                                _this.getMobileCodeTxt = seconds + "s";
                            } else {
                                _this.getMobileCodeTxt = "点击获取";
                                _this.isCanGetMobileCode = true;
                                clearInterval(timer);
                            }
                        }, 1000);
                    }
                }).catch(function () {
                    _this.loading = false;
                    _this.$Message.error('数据获取失败,请稍后再试!');
                });
            }, 1000);
        },
        changeTabShow: function changeTabShow(index) {
            var _this = this;
            _this.title.forEach(function (item, i) {
                if (index == i) {
                    _this.title[i].isSelected = true;
                    _this.isShowTab1 = false;
                } else {
                    _this.title[i].isSelected = false;
                    _this.isShowTab1 = true;
                }
            });
        },
        closeLoginDialog: function closeLoginDialog() {
            this.$store.commit('changeShowLoginDialogState');
        }
    }
});

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_url__ = __webpack_require__("FKvS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_common__ = __webpack_require__("/sA3");





var actions = {
    /*
    *  获取购物车数量
    * */
    getCartNum: function getCartNum() {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].getCartNum, {
            params: {
                userType: 1
            }
        }).then(function (res) {
            if (res.data.result != null) {
                __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */].cartNum = res.data.result;
            }
        }).catch(function () {
            console.log('数据获取失败,请稍后再试!');
        });
    },

    /*
    *  获取用户信息
    * */
    getUserInfo: function getUserInfo(context, payload) {
        __WEBPACK_IMPORTED_MODULE_3__static_js_common__["a" /* default */].addCasIframe(function () {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__config_url__["a" /* default */].getUserInfo).then(function (res) {
                if (res.data.result != null) {
                    __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */].userInfo = res.data.result;
                    if (res.data.result.userId != null) {
                        context.userId = res.data.result.userId;
                        if (payload != null && typeof payload == "function") {
                            payload();
                        }
                    }
                }
            }).catch(function () {
                console.log('数据获取失败,请稍后再试!');
            });
        });
    },
    getDefaultCity: function getDefaultCity(context, payload) {
        context.state.defaultCity = payload;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ "mgpx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "muDP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nCrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sideBar_vue__ = __webpack_require__("k0Uf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626c5db0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sideBar_vue__ = __webpack_require__("Ufbt");
function injectStyle (ssrContext) {
  __webpack_require__("tjHU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-626c5db0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626c5db0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pYmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("7oBO");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_daaebb18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("mgpx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_daaebb18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pdvb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-wrap"},[_c('div',{staticClass:"header"},[_c('a',{staticClass:"logo",attrs:{"href":_vm.webRoot}},[_c('img',{attrs:{"src":_vm.imgLogo}})]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-box"},[_c('Select',{staticClass:"select-type",staticStyle:{"width":"80px"},on:{"on-change":function($event){_vm.getSearchHolderItem()}},model:{value:(_vm.defaultSearchHolder.hotWordTypeName),callback:function ($$v) {_vm.$set(_vm.defaultSearchHolder, "hotWordTypeName", $$v)},expression:"defaultSearchHolder.hotWordTypeName"}},_vm._l((_vm.searchHolder),function(item,index){return _c('Option',{key:item.hotWordTypeName,attrs:{"value":item.hotWordTypeName}},[_vm._v(_vm._s(item.hotWordTypeName))])})),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],attrs:{"type":"text","placeholder":_vm.defaultSearchHolder.placeHolder},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":_vm.goSearch}},[_c('i')])],1),_vm._v(" "),_c('div',{staticClass:"hot-words"},_vm._l((_vm.defaultSearchHolder.hotWordVOList),function(item){return _c('a',{attrs:{"target":"_blank","href":_vm.returnHotWordsLink(item.hotWord)}},[_vm._v(_vm._s(item.hotWord))])}))]),_vm._v(" "),_c('div',{staticClass:"hot-line"},[_c('img',{attrs:{"src":_vm.hot_line,"alt":""}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rpep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simpleHeaderBar_vue__ = __webpack_require__("eOkT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f440e80c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simpleHeaderBar_vue__ = __webpack_require__("h3en");
function injectStyle (ssrContext) {
  __webpack_require__("tbln")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f440e80c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simpleHeaderBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f440e80c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simpleHeaderBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tbln":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tjHU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWrB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "udc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("kME/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95a74dec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Qjqv");
function injectStyle (ssrContext) {
  __webpack_require__("uWrB")
  __webpack_require__("XPqd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95a74dec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95a74dec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    //切换登录弹框的显示与隐藏
    changeShowLoginDialogState: function changeShowLoginDialogState(state) {
        state.isShowLoginDialog = !state.isShowLoginDialog;
    },
    setKeyWord: function setKeyWord(state) {
        var path = window.location.href.toLocaleLowerCase();
        var path_arr = path.split("/");
        path_arr.forEach(function (item) {
            if (item.indexOf("sou") > -1) {
                state.keyWord = decodeURIComponent(item.replace("sou", ""));
            }
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "wcOv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zse5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "resources/static/img/icon_police.png";

/***/ }),

/***/ "zv4U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("BYLM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5edebfe8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ieZ+");
function injectStyle (ssrContext) {
  __webpack_require__("bEVD")
  __webpack_require__("kjeq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5edebfe8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5edebfe8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// resources/static/js/app.js?v=9b57dfaa5515d594fd43